export const es = {
  translation: {
    analytics: {
      title: 'Analítica',
      period: 'Período:',
      selectPeriod: 'Seleccionar período',
      qrCode: 'Código QR:',
      selectQrCode: 'Seleccionar código QR',
      operatingSystem: 'Sistema operativo:',
      selectOperatingSystem: 'Seleccionar sistema operativo',
      countries: 'Países:',
      selectCountries: 'Seleccionar países',
      cities: 'Ciudades:',
      selectCities: 'Seleccionar ciudades',
      totalQrCodes: 'Total de códigos QR',
      totalScans: 'Total de escaneos',
      totalUniqueScans: 'Total de escaneos únicos',
      totalUniqueScansTooltip:
        '"Total de escaneos únicos" se refiere al número distinto de usuarios que han realizado al menos un escaneo dentro del período de tiempo elegido, contando cada usuario solo una vez.',
      totalVisits: 'Total de visitas',
      qrCodeScanActivities: 'Actividades de escaneo de códigos QR',
      analyzedPeriod: 'Período analizado:',
      noDataStatistics: 'No hay suficientes datos para mostrar estadísticas.',
      scansByOperatingSystems: 'Escaneos por sistemas operativos',
      scansByCountry: 'Escaneos por país',
      scansByRegionCity: 'Escaneos por región / ciudad',
      reportsNotRealTime: 'Los informes no se generan en tiempo real, pueden tener un retraso de hasta 5 minutos.',
      tooltipCountry:
        'Usamos Maxmind para la geolocalización por IP. La precisión varía según la ubicación del servidor y el uso de VPN.',
      tooltipCity:
        'Usamos Maxmind para la geolocalización por IP. La precisión varía según la ubicación del servidor y el uso de VPN.',
      periodOptions: {
        today: 'Hoy',
        yesterday: 'Ayer',
        last7days: 'Últimos 7 días',
        last30days: 'Últimos 30 días',
        last90days: 'Últimos 90 días',
        lifetime: 'De por vida',
        custom: 'Personalizado',
      },
      qrCodeOptions: {
        all: 'Todos',
        myBirthday: 'Mi cumpleaños',
        myWebsite: 'Mi sitio web',
      },
      operatingSystemOptions: {
        all: 'Todos',
        android: 'Android',
        ios: 'IOS',
      },
      countriesOptions: {
        all: 'Todos',
        thailand: 'Tailandia',
        usa: 'EE.UU.',
      },
      citiesOptions: {
        all: 'Todos',
        newYork: 'Nueva York',
        toronto: 'Toronto',
      },
    },
    alerts: {
      instructionsForQRCodePreview: 'Complete los datos y podrá previsualizar su código QR',
      login: '¡Error! El servidor no está respondiendo. Contacta a tu proveedor de servicios.',
      nif_info: 'Para emitir una factura válida, es necesario indicar su NIF, por ejemplo, ES12345678',
      timeRemaining: 'días restantes',
      socialError: '¡Ocurrió un error! El formulario de inicio de sesión contiene un error o fue cerrado.',
      subscriptionExpired: 'El período de prueba ha terminado',
      editType: 'Cambiar el tipo de QR eliminará los datos actuales.',
      successCopiedToClipboard: 'Texto copiado al portapapeles',
    },
    buttons: {
      addNew: 'Agregar nuevo',
      forDev: 'Desarrolladores',
      supp: 'Soporte',
      upgradeNow: 'Actualizar ahora',
      detail: 'Detalle',
      edit: 'Editar',
      download: 'Descargar',
      back: 'Atrás',
      upload: 'Subir archivo',
      delete: 'Eliminar',
      deleteQRcode: 'Delete QR Code',
      addLink: 'Agregar enlace',
      addCoverLogo: 'Agregar imagen de portada',
      addImage: 'Agregar imagen',
      logOutBtn: 'Cerrar sesión',
      addLogo: 'Agrega tu logo',
      preview: 'Vista previa',
      qrCode: 'Código QR',
      pause: 'Pausa',
      start: 'Iniciar',
      planPrice: 'Planes y precios',
      faq: 'Preguntas frecuentes',
      home: 'Casa',
      api: 'API',
      resources: 'Recursos',
      login: 'Iniciar Sesión',
      signUp: 'Regístrate',
      loginCreate: 'Inicia sesión para Crear',
      downloadQr: 'Descargar QR',
      activate: 'Activar',
      cancel: 'Cancelar',
      close: 'Cerrar',
      proceed: 'Continuar',
      deletePermanently: 'Eliminar permanentemente',
      exit: 'Cerca',
      createQrCode: 'Crear código qr',
      activateAccount: 'Activar cuenta',
      create: 'Crear',
      save: 'Ahorrar',
      active: 'Activa',
      saveTo: 'Guardar en',
      submit: 'Enviar',
    },
    general: {
      complete: 'Completar',
      qrCodePreviewTitle: '¡Escanéame!',
      qrCoderPreviewText: `IMPORTANTE: No olvides probar tu código QR`,
      important: 'Importante',
      readabilityQr:
        'La legibilidad de este diseño de código QR puede no ser ideal. Sugerimos probar el código QR escaneándolo para confirmar que funcione correctamente.',
    },
    socialButtons: {
      googlePlayText: 'CONSÍGUELO EN',
      googlePlayTitle: 'Google Play',
      appleText: 'Descargar en la',
      appleTitle: 'App Store',
    },
    errors: {
      invalidHexCode: 'El color no es válido',
      maxLength: 'La longitud máxima es de 2000 símbolos',
      scanMinNumber: 'El límite de escaneo debe ser al menos 1',
      scan_limit: 'Debe ser menor o igual a 10000000',
      url_1: 'La URL debe comenzar con http:// o https://',
      url_2: 'La URL debe ser válida',
      emailIsValid: 'Correo electrónico no válido.',
      phoneCode: 'Código de área no válido',
      phoneIsValid: 'Número de teléfono inválido',
      url: 'La URL debe comenzar con http:// o https://',
      max: 'La longitud máxima es de {{count}} símbolos',
    },
    inputs: {
      required: 'Campo obligatorio',
    },
    titles: {
      socialMediaMicroSiteTitle: 'Encuéntrame en:',
      link: 'Enlace',
    },
    labels: {
      selected: 'Seleccionada',
      noTracking: 'Sin seguimiento',
      headerTitle: 'Ejemplo de Título Base',
      myQrTitle: 'Mis códigos QR',
      all: 'Todos',
      static: 'Estático',
      dynamic: 'Dinámico',
      info: 'Información',
      url: 'URL',
      linkText: 'Texto del enlace',
      metrics: 'Métricas',
      action: 'Acción',
      createTime: 'Creado: {{time}}',
      scans: 'Escaneos',
      staticTootip: 'Este código QR es estático y no permite el seguimiento, por lo que no habrá registro de escaneos.',
      website: 'Sitio web',
      defaultTrialWarningMessage:
        'Tu prueba gratuita finalizará el {{endTime}}, después de esa fecha tus códigos QR serán desactivados.',
      defaultPlanErrorMessage:
        'Su suscripción ha expirado. La funcionalidad está limitada hasta que se realice el pago.',
      pauseQrCodeNotification:
        'Tenga en cuenta que la disponibilidad de este código QR se ha suspendido. Para continuar su disponibilidad, actívelo nuevamente.',
      dragAndDrop1: 'Haz clic para subir',
      dragAndDrop2: 'o arrastra y suelta',
      addMore: 'Agregar más',
      max: 'máx',
      name: 'Nombre',
      description: 'Descripción',
      text: 'Texto',
      textColor: 'Color del texto',
      https: 'https://',
      paused: 'Pausado',
      scanLimit: 'Límite de escaneo',
    },
    placeholders: {
      default: 'Marcador de posición',
    },
    qrDetail: {
      media: 'Medios',
      print: 'Imprimir',
      totalScan: 'Total de escaneos',
      titleScanAtivity: 'Actividad de escaneo',
      titleScanOC: 'Escaneo por sistema operativo',
      oc: 'Sistema operativo',
      titleScanCountry: 'Escaneo por país',
      country: 'País',
      region: 'Región',
      browser: 'Navegador',
      titleScanRegion: 'Escaneo por región/ciudad',
      titleScanBrowser: 'Escaneos por navegador',
      titleScanLang: 'Escaneos por idioma del usuario',
      day: 'Día',
      month: 'Mes',
      year: 'Año',
      lastHours: 'Hoy',
      lastDays: 'Mes Actual',
      lastMonth: 'Año Actual',
      total: 'Total',
      unique: 'Único',
      visits: 'Visita a la vista previa',
    },
    other: {
      selectedItems: 'artículos seleccionados',
      months: 'meses',
      rowsPerPage: 'Filas por página:',
      maxLength: 'La longitud máxima es de {{maxLength}} símbolos',
      title: 'Título',
      text: 'Texto',
      titleColor: 'Color del título',
      textsColor: 'Color de los textos',
      company: 'Compañía',
      description: 'Descripción',
      website: 'Sitio web',
      button: 'Botón',
      default: 'Predeterminado',
      template: 'Plantilla {{templateId}}',
      vertical: 'Vertical',
      horizontal: 'Horizontal',
      grid: 'Cuadrícula {{gridId}}',
      phone: 'Teléfono',
      name: 'Nombre',
      profession: 'Profesión',
      location: 'Ubicación',
      email: 'Correo electrónico',
      imageAlbum: 'Título de imagen / foto / álbum',
      btnTxt: 'Texto del botón',
      images: 'PNG, JPEG',
      showLink: 'Mostrar enlace de dirección',
      hideLink: 'Ocultar enlace de dirección',
      showMap: 'Mostrar el mapa',
      surname: 'Apellido',
      appName: 'Nombre de la aplicación',
      developerCompany: 'Desarrolladora/Empresa',
      titlePosition: 'Posición del título',
      label: 'Etiqueta',
      processing: 'Los archivos se están procesando...',
      address: 'Dirección',
      subject: 'Asunto',
      message: 'Mensaje',
    },
    thirdStep: {
      designQr: 'Diseñar el QR',
      frame: 'Marco',
      frameColour: 'Color del marco',
      useGradients: '¿Usar gradientes?',
      bgColor: 'Color de fondo',
      transparentBg: 'Fondo transparente',
      qrCodeStyle: 'Estilo del código QR',
      qrText:
        '¡Recuerda! Para una lectura óptima del código QR, necesitas usar colores de alto contraste. Recomendamos seleccionar un color claro y un color oscuro para tu código QR.',
      shape: 'Forma',
      corners: 'Esquinas',
      borderStyle: 'Estilo de borde',
      centerStyle: 'Estilo del centro',
      cornerBorderColour: 'Color del borde de las esquinas',
      cornerCenterColour: 'Color del centro de las esquinas',
      correctionLevel: 'Nivel de corrección',
      addLogo: 'Agregar logo',
      gradientType: 'Tipo de gradiente',
      level: 'Nivel',
      uploadLogo: 'Sube tu logo',
      selectLogo: 'Selecciona logo',
      color: 'Color',
    },
    sidebar: {
      newQr: 'Nuevo QR',
      analytics: 'Analítica',
      myQRCodes: 'Mis códigos QR',
      myAccount: 'Mi cuenta',
      payments: 'Pagos',
      hideSidebar: 'Ocultar barra lateral',
    },
    login: {
      welcome: '¡Bienvenido!',
      text: 'Ingresa con tus redes o completa tu correo electrónico para trabajar con QRs',
      googleButton: 'INICIAR SESIÓN CON GOOGLE',
      facebookButton: 'INICIAR SESIÓN CON FACEBOOK',
      googleButtonSignUp: 'REGISTRARSE CON GOOGLE',
      facebookButtonSignUp: 'REGISTRARSE CON FACEBOOK',
      emailInput: 'Dirección de correo electrónico',
      emailLogin: 'INICIAR SESIÓN',
      emailLoginSignUp: 'REGISTRARSE',
      popuph1: 'Último paso',
      popuph2: 'Regístrate para guardar y administrar tus códigos QR.',
      confirmationh2: 'Te acabamos de enviar un enlace de confirmación a tu correo electrónico,',
      confirmationh3: 'solo haz clic en él y estarás registrado.',
      createAccount: 'Crear cuenta',
      createTitle: 'Ingresa tu correo electrónico para finalizar la creación de la cuenta',
      bottomTitle: 'Al crear una cuenta, usted consiente',
      bottomTitle1: 'que ha leído y está de acuerdo con nuestros',
      bottomTitle2: 'Términos de Servicio.',
    },
    signIn: {
      title: '¡Bienvenido de nuevo!',
      subtitle: 'Inicia sesión con Google o utiliza tu correo electrónico',
      dividerText: 'O, inicia sesión con tu correo electrónico',
      registerLink: '¿No tienes una cuenta? <1>Crea una cuenta</1>',
      inputs: {
        email: {
          placeholder: 'Ingresa tu correo electrónico...',
        },
      },
      buttons: {
        signInWithGoogle: 'Inicia sesión con Google',
        login: 'Iniciar sesión',
      },
      loginGoogle: 'Or, log in with Google',
    },
    signUp: {
      title: 'Regístrate',
      subtitle: 'Crea una cuenta gratis',
      dividerText: 'O, regístrate con tu correo electrónico',
      loginLink: '¿Ya tienes una cuenta? <1>Inicia sesión</1>',
      byCreatingAccountYouAgree:
        'Al crear una cuenta, aceptas que has leído y estás de acuerdo con nuestros <1>Términos y Condiciones</1> y la <2>Política de Privacidad</2>.',
      inputs: {
        email: {
          placeholder: 'Ingresa tu correo electrónico...',
        },
      },
      buttons: {
        signUpWithGoogle: 'Regístrate con Google',
        signUp: 'Regístrate',
      },
      slides: {
        0: {
          title: 'Elige el contenido de tu código QR',
          desc: 'Crea códigos QR para cualquier cosa: sitios web, archivos PDF, imágenes, enlaces, vCards y más. Personalízalo para que se ajuste a tus necesidades.',
        },
        1: {
          title: 'Personaliza y diseña tu código QR',
          desc: 'Añade tus detalles y utiliza nuestro generador para crear un código QR único para ti.',
        },
        2: {
          title: 'Descarga tu código y compártelo',
          desc: 'Crea códigos QR para cualquier cosa: sitios web, archivos PDF, imágenes, enlaces, vCards y más. Personalízalo para que se ajuste a tus necesidades.',
        },
      },
      google: 'Or, sign up with Google',
    },
    confirmation: {
      p1: 'Por favor revisa tu correo electrónico',
      p2: 'Te acabamos de enviar un enlace de confirmación.',
      p3: 'Haz clic en el enlace y estarás registrado.',
      p4: '¿Cometiste un error al ingresar los datos?',
      p5: '¿No recibiste el correo?',
      p6: 'Intenta esperar un par de minutos o',
      p6_end_text: 'Contacta con el soporte',
      btnText: 'Cambiar correo electrónico',
    },
    createQrStep1: {
      created: 'Creado',
      p1: 'Tipo de código QR',
      p2: 'Contenido',
      p3: 'Diseño del QR',
      btn1: 'Atrás',
      btn2: 'Siguiente',
      btn3: 'Completo',
      h1: 'QR Dinámico',
      h2: 'Actualiza el contenido en tiempo real, sin cambiar tu código.',
      h3: 'QR Estático',
      label1: 'Con seguimiento',
      label2: 'Sin seguimiento',
      label3: 'Borrador',
      staticDescription: 'Se requiere reimpresión al actualizar el contenido.',
      items: {
        b1: { name: 'Sitio web', subName: 'Abrir una URL' },
        b2: { name: 'PDF', subName: 'Mostrar un PDF' },
        b3: { name: 'Lista de enlaces', subName: 'Agrupar enlaces' },
        b4: { name: 'Aplicaciones', subName: 'Redirigir a una tienda de aplicaciones' },
        b5: { name: 'Imágenes', subName: 'Mostrar una galería de imágenes' },
        b6: { name: 'vCard Plus', subName: 'Compartir detalles de contacto' },
        b7: { name: 'Redes sociales', subName: 'Un árbol para todas tus redes sociales' },
        b8: { name: 'Cupón', subName: 'Comparte un cupón' },
        b9: { name: 'Vídeo', subName: 'Mostrar un vídeo' },
        c1: { name: 'URL', subName: 'Abrir una URL' },
        c2: { name: 'Texto', subName: 'Mostrar texto simple' },
        c3: { name: 'Wi-Fi', subName: 'Conectar a una red Wi-Fi' },
        c4: { name: 'Correo electrónico', subName: 'Enviar un correo electrónico con texto predefinido' },
        c5: { name: 'vCard', subName: 'Compartir y almacenar tus detalles de contacto' },
        c6: { name: 'SMS', subName: 'Enviar un mensaje de texto' },
        c7: { name: 'Whatsapp', subName: 'Enviar un mensaje de Whatsapp' },
      },
      previewTitle: 'Ejemplo',
      preview: 'Vista previa',
      alertClose: 'Entendido',
      rememberAboutPreview:
        'Recuerda que puedes previsualizar y probar tus códigos QR haciendo clic en el botón “Código QR”.',
    },
    editor: {
      headerTitle: 'Completa el contenido del QR',
      headerInputPlaceholder: 'Nombre de tu código QR...',
    },
    basicTemplateLabels: {
      //Titles block
      appearanceTitle: 'Apariencia',
      appearanceSubTitle: 'Personaliza el estilo y la plantilla.',
      basicInfoTitle: 'Información básica',
      basicInfoSubTitle: 'Agregar información esencial',
      contentTitle: 'Contenido',
      contentSubTitle: 'Todos los detalles sobre tu QR',
      statsTitle: 'Estadísticas',
      statsSubTitle: 'Herramientas y datos clave para evaluar el rendimiento',
      //Titles section
      tmplPreview: 'Seleccionar plantilla',
      tmplDesign: 'Diseño',
      tmplFonts: 'Fuentes',
      socilaNet: 'Redes sociales',
      //preview titles
      websiteTitle: 'Generador de código QR',
      settings: 'Configuración Avanzada',
      nameAndOrganisation: {
        title: 'Nombre y Organización',
        description: 'Asigna un nombre a tu código QR y organízalo en carpetas.',
        name: 'Nombre',
        namePlaceholder: 'Ej.: Mi Código QR',
      },
      passwordProtection: {
        title: 'Protección con Contraseña',
        description: 'Agregar protección con contraseña',
        switchLabel: 'Activar contraseña para acceder al código QR.',
        inputLabel: 'Contraseña',
        inputPlaceholder: 'Ingresa tu contraseña...',
        modalTitle: 'Ingresar Contraseña',
        modalDesc: 'Si deseas acceder a este QR, necesitas obtener la contraseña adecuada.',
      },
    },
    template0: {
      title1: 'Información básica',
      subTitle1: 'Agregar información esencial',
      title2: 'Información del sitio web',
      label1: 'URL del sitio web',
      placeholder1: 'Ej. https://pagina-de-destino.com/',
      title3: 'Estadísticas',
      subTitle2: 'Herramientas y datos clave para evaluar el rendimiento',
      title4: 'Configuración de URL',
      subTitle3: 'Personaliza tu identificador de dirección qr-gen.me',
      sliderTitle1: 'Generar automáticamente',
      placeholder2: 'https://qr-gen.me/p/generado-automáticamente',
      notification:
        'Los cambios en la URL corta de un código QR ya publicado causarán que la versión anterior del código QR sea sobrescrita y ya no será escaneable. Será necesario imprimir el código QR nuevamente.',
      title5: 'Límites de escaneo',
      subTitle4: 'Limita el número de veces que tu QR puede ser escaneado en total',
      sliderTitle2: 'Habilitar límite de escaneo',
    },
    template1: {
      uploader: 'Subir archivo',
      uploaderDesc: 'Mostrar directamente el archivo PDF',
      pdfInfo: 'Información del PDF',
      primary: 'Primario',
      secondary: 'Secundario',
      bg: 'Fondo',
      bgLink: 'Fondo del enlace',
      colorLink: 'Color del texto del enlace',
      error: 'Debe tener al menos 1 elemento',
    },
    template2: {
      titleSize: 'Tamaño del título',
      descriptionSize: 'Tamaño de la descripción',
      socialSize: 'Tamaño de redes sociales',
      titleLink: 'Información de la lista de enlaces',
      titleContent: 'Contenido',
      subTitleContent: 'Todos los detalles sobre tu QR',
      seconTitleLink: 'Enlace',
      links: 'Enlaces',
      linkText: 'Texto del enlace',
      writeHere: 'Escribe aquí el texto del enlace',
      titleImages: 'Imágenes',
    },
    template3: {
      appInfo: 'Información de la aplicación',
      addLogo: 'Agrega tu logo',
    },
    template5: {
      about: 'Acerca de ti',
      constactInfo: 'Información de contacto',
      location: 'Ubicación',
      locationOpt: 'Opciones de ubicación',
      complete: 'Completar',
      url: 'URL',
      coordinate: 'Coordenadas',
      addPhone: 'Agregar teléfono',
      addEmail: 'Agregar correo electrónico',
      addWeb: 'Agregar sitio web',
      addCompany: 'Agregar empresa',
      image: 'Imagen',
      companies: 'Empresas',
      custBtnText: 'Personaliza tus botones',
      custBtnTextSub: 'Edita los textos de los accesos directos',
      header: 'Encabezado',
      footer: 'Pie de página',
      contactStore: 'Opciones de almacenamiento de contactos',
      contactTopLabel: `"Agregar contacto" en la parte superior`,
      floatingLabel: 'Botón flotante',
      titleOnly: 'Solo título',
      orgOnly: 'Solo organización',
      orgAndTitle: 'Organización y título',
      summary: 'Resumen',
      manual: 'Entrada manual',
      delete_address: 'Eliminar dirección',
      latitude: 'Latitud',
      longitude: 'Longitud',
      downloadQr: 'Descargar QR',
      street: 'Calle',
      strNumber: 'Número',
      postCode: 'Código Postal',
      city: 'Ciudad',
      state: 'Estado / Provincia',
      country: 'País',
      titlePosition: {
        left: 'Izquierda',
        right: 'Derecha',
        center: 'Centro',
      },
      phoneType: {
        mobile: 'Móvil',
        work: 'Trabajo',
        home: 'Casa',
        fax: 'Fax',
        other: 'Otro',
      },
      showMap: 'Mostrar en el mapa',
      searchAddress: 'Search address',
      yourAvatar: 'Your avatar',
      coverImage: 'Cover image',
    },
    template6: {
      imageInfo: 'Información de la imagen',
      addBtn: 'Agregar botón',
      socialmedia: 'Información de redes sociales',
      placeholder: {
        p1: 'Ej. Mis fotos',
        p2: 'Ej. Viajes 2019',
        p3: 'Ej. https://miwebsite.com',
      },
    },
    staticQrTemplates: {
      wifi: {
        mockup: {
          title: '¿Unirse a la red Wi-fi “Hotel Bar”?',
          accept: 'Aceptar',
          cancel: 'Cancelar',
        },
        content: {
          title: 'Información de Wi-Fi',
          fields: {
            ssid: {
              label: 'Nombre de la red (SSID)',
              placeholder: 'Ej. HomeWifi',
            },
            password: {
              label: 'Contraseña de la red',
              placeholder: 'Ej. Mipassword',
            },
            authType: {
              label: 'Tipo de encriptación',
            },
            hidden: {
              label: 'Red oculta',
            },
          },
        },
      },
      sms: {
        mockup: {
          number: 'Número',
          message: 'Mensaje',
        },
        content: {
          title: 'Información del SMS',
          fields: {
            number: {
              label: 'Número',
              placeholder: 'Ingresa el número',
            },
            message: {
              label: 'Mensaje',
              placeholder: 'Ingresa el mensaje',
            },
          },
        },
      },
      whatsapp: {
        mockup: {
          number: 'Número',
          message: 'Mensaje',
        },
        content: {
          title: 'Información de Whatsapp',
          fields: {
            number: {
              label: 'Número',
              placeholder: 'Ingresa el número',
              info: 'El número debe tener el prefijo del país',
            },
            message: {
              label: 'Mensaje',
              placeholder: 'Ingresa el mensaje',
            },
          },
        },
      },
      text: {
        content: {
          fields: {
            text: {
              title: 'Texto',
              label: 'Mensaje',
              placeholder: 'Introduce algo de texto...',
            },
          },
        },
      },
      email: {
        content: {
          title: 'Información del correo electrónico',
        },
      },
    },
    settings: {
      settingsTitle: 'Configuración',
      tab1: 'Información general',
      tab2: 'Información fiscal',
      saveBtn: 'Guardar',
      titleSection1: 'Información de contacto',
      Language: 'Idioma',
      titleSection3: 'Zona horaria',
      titleSection5: 'Fecha y hora',
      titleSection4: 'Detalles de la cuenta',
      titleSection6: 'Miles',
      subscribeTitle: 'Preferencias de correo electrónico',
      subscribeDesc:
        'Darse de baja si no deseas recibir correos electrónicos con información importante sobre tu cuenta.',
      subscribeDesc2:
        'Si te suscribes, recibirás correos electrónicos con actualizaciones importantes e información sobre tu cuenta.',
      unsubBtn: 'Darse de baja',
      subBtn: 'Suscribirse',
      accTitle: 'Estado de la cuenta',
      accDesc:
        'Puedes eliminar tu cuenta si estás seguro de que nuestro servicio nunca te será útil nuevamente. Tus datos serán eliminados permanentemente.',
      deleteAccBtn: 'Eliminar cuenta',
      hoursFormat: 'Formato de horas',
      dateFormat: 'Formato de fecha',
      individualBtn: 'Individual',
      companyBtn: 'Nombre de la empresa',
      optional: '(Opcional)',
      country: 'País',
      nif: 'Identificación Fiscal',
      name: 'Nombre',
      surname: 'Apellido',
      adress: 'Dirección',
      city: 'Ciudad',
      postCode: 'Código postal',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      phoneCode: 'Código',
      placeholdPhoneCode: 'Ej. +44',
      placeholdCompany: 'Ej. Mi empresa',
      placeholdNIF: 'Ej. 43468392N',
      placeholdName: 'Ej. María',
      placeholdSurname: 'Ej. Pérez',
      placeholdEmail: 'Ej. nombre@correo.com',
      placeholdAddress: 'Ej. Calle Principal',
      placeholdCity: 'Ej. Madrid',
      placeholdPost: 'Ej. 28028',
      informationUpdated: '¡Información actualizada!',
      languageUpdated: '¡Idioma actualizado!',
      timeUpdated: '¡Zona horaria actualizada!',
      dateUpdated: '¡Fecha y hora actualizadas!',
      thousandsUpdated: '¡Separador de miles actualizado!',
    },
    downloadModal: {
      title: 'Guardar como...',
      jpeg: 'Archivo de imagen estándar.',
      png: 'Archivo con fondo transparente.',
      svg: 'Archivo vectorial.',
      pdf: 'Formato de archivo universal.',
      eps: 'Archivo vectorial editable.',
    },
    supportModal: {
      title: 'Escríbenos tu consulta',
      inputLabel1: 'Motivo*',
      inputLabel2: 'Etiqueta*',
      placeholder2: 'Escribe un asunto',
      inputLabel3: 'Consulta*',
      cancelBtn: 'Cancelar',
      sendBtn: 'Enviar',
    },
    upgradeModal: {
      logoText: 'Actualiza para seguir utilizando QRbrain.io',
      title: 'Reactivado hoy y mantente en control',
      subTitle:
        'Recupera el acceso completo a todas las funciones de tu plataforma de gestión de códigos QR sin interrupciones. Reactiva ahora y disfruta de:',
      listItem1: 'Restaurar todos los códigos QR pausados de inmediato.',
      listItem2: 'Generar y modificar códigos QR según sea necesario.',
      listItem3: 'Monitorear escaneos, participación y análisis de rendimiento.',
      listItem4: 'Editar colores, logotipos y diseños para que coincidan con tu marca.',
      listItem5: 'Elegir entre múltiples formatos como URL, vCard, PDFs y más.',
      listItem6: 'Asegurar que tus códigos QR funcionen sin limitaciones de escaneo.',
      listItem7: 'Exportar códigos QR en varios formatos de alta calidad.',
      listItem8: 'Obtener asistencia experta cuando la necesites.',
      listItem9: 'Cancelar en cualquier momento.',
      buttonText: 'Actualizar mi cuenta',
    },
    uploaderModal: {
      title: 'Subir foto',
      saveBtn: 'Guardar',
      zoom: 'Zoom',
      roundness: 'Redondez',
      rotateBtn: 'Rotar',
      resetBtn: 'Restablecer',
    },
    payments: {
      title: 'Planes y pagos',
      bestValue: 'MEJOR VALOR',
      ourBenefits: 'Our Benefits',
      month: 'mes',
      description: 'Suscríbete al plan que mejor se adapte a tus necesidades.',
      footerNote: 'Impuesto sobre el valor añadido no incluido en los montos.',
      buyBtn: 'Comprar una suscripción',
      mangeSubscription: 'Administrar suscripciones',
      list: {
        a1: 'Crear QR estáticos y dinámicos ilimitados',
        a2: 'Variedad de tipos de QR',
        a3: 'Edición y gestión de códigos QR',
        a4: 'Escaneos ilimitados',
        a5: 'Soporte premium',
        a6: 'Cancelar cuando quieras',
        a7: 'Estadísticas detalladas',
      },
      bestValue50: 'Mejor Valor - Ahorra 50%',
      save50PercentAnnually: 'Ahorra un 50% anualmente',
      savePercentAnnually: 'Ahorra {{percentOff}}% anualmente',
      plansAdnServices: {
        plans: {
          title0: 'Crea QRs ilimitados',
          title1: 'Variedad de tipos de QR',
          title2: 'Variedad de formatos de descarga',
          title3: 'Analíticas completas de QR',
          title4: 'Edición y gestión',
          title5: 'Escaneos ilimitados',
          title6: 'Dominio personalizado',
          subTitle0: 'Crea QRs ilimitados y actualízalos en tiempo real cuando lo desees.',
          subTitle1: 'Elige entre múltiples tipos de QR, como Sitios web, archivos PDF, imágenes y más.',
          subTitle2: 'Descarga tu QR en PNG, SVG, PDF, entre otros.',
          subTitle3: 'Obtén estadísticas sobre el número de escaneos, ubicaciones y dispositivos de los usuarios.',
          subTitle4: 'Personaliza tus QRs con colores, fuentes y logotipo.',
          subTitle5: 'Tus QRs pueden ser escaneados un número ilimitado de veces.',
          subTitle6: 'Usa tu propio dominio para personalizar la URL de tus QRs.',
        },
      },
    },
    checkout: {
      selectPlan: 'Seleccionar plan',
      summaryTitle: 'Resumen',
      period: 'meses',
      total: 'TOTAL',
      paymentSecure: 'PAGO SEGURO',
      paymentMethods: 'Métodos de pago aceptados',
      cancelBtn: 'Cancelar',
      nextBtn: 'Siguiente',
      successfullPayment: 'Pago exitoso',
      successfullPaymentText:
        'Ahora puede usar la plataforma para crear y rastrear códigos QR de manera conveniente al máximo.',
      continue: 'Continuar',
      summayList: {
        a1: 'Tu plan seleccionado estará listo para ser usado inmediatamente.',
        a2: 'Recibirás una factura por correo electrónico con tus detalles de facturación.',
        a3: 'Puedes cambiar el plan en cualquier momento.',
        a4: 'Si no estás completamente satisfecho, te devolveremos tu dinero.',
      },
      step1: 'Facturación',
      step2: 'Método de pago',
      active: 'ACTIVA',
    },
    api: {
      header: 'API',
      description: 'Crea códigos QR estáticos y dinámicos donde quieras en cuestión de segundos.',
      tabs: {
        item_2: 'Eliminar códigos QR',
        item_3: 'Listar códigos QR',
      },
      titleDesign: 'Ejemplo de diseño de código QR simple',
      titleColor: 'Ejemplo de código QR con colores',
      code: {
        titleMethod: 'Método de solicitud:',
        titleUrl: 'URL de solicitud:',
        titleParameters: 'Parámetros de solicitud:',
        paramDescription: 'Todos los parámetros deben enviarse como un objeto JSON en el cuerpo de la solicitud.',
        outcome: 'Resultado:',
      },
      table: {
        main: 'Parámetros principales:',
        colorShape: 'Parámetros de color y forma:',
        frame: 'Parámetros de marco:',
      },
    },
    unauthQr: {
      website: {
        title: 'URL del sitio web',
        description: 'Redirigir a sitio web',
        appearance: {
          frame: 'MARCO',
          shape: 'FORMA',
          logo: 'LOGO',
          level: 'NIVEL',
        },
      },
      pdf: {
        title: 'QR PDF',
        description: 'Mostrar un PDF',
      },
      listofLinks: {
        title: 'QR Lista de Enlaces',
        description: 'Agrupar enlaces',
      },
      apps: {
        title: 'QR Aplicaciones',
        description: 'Redirigir a una tienda de aplicaciones',
      },
      images: {
        title: 'QR Imágenes',
        description: 'Mostrar una galería de imágenes',
      },
      social: {
        title: 'QR Redes sociales',
        description: 'Compartir tus perfiles sociales',
      },
    },
    month: {
      1: 'Enero',
      2: 'Febrero',
      3: 'Marzo',
      4: 'Abril',
      5: 'Mayo',
      6: 'Junio',
      7: 'Julio',
      8: 'Agosto',
      9: 'Septiembre',
      10: 'Octubre',
      11: 'Noviembre',
      12: 'Diciembre',
    },
    expirePopup: {
      title: 'Su plan de prueba expirará en',
      days: 'Días',
      hours: 'Horas',
      minutes: 'Minutos',
      after: 'Después',
      afterNext: ', perderá acceso a las siguientes características:',
      text1: 'Sus códigos QR dinámicos ya no serán escaneables.',
      text2: 'No podrá crear nuevos códigos QR ni editar los existentes.',
      text3: 'Perderá acceso a todas sus métricas de seguimiento.',
      text4: 'Las descargas ya no estarán disponibles.',
      bottomText: 'Para continuar usando la plataforma sin interrupciones, actualice a uno de nuestros planes.',
    },
    errorPages: {
      couldNotLod: 'No se pudo cargar la página, por favor inténtelo de nuevo más tarde.',
      poweredBy: 'Desarrollado por',
      limitReached: 'Se ha alcanzado el límite de escaneos totales.',
      qrDeactivated: 'Este código QR ha sido desactivado por alguna razón',
      qrDeactivatedSubTitle1: 'Si eres el propietario de este código QR, ',
      qrDeactivatedSubTitle2: 'inicia sesión',
      qrDeactivatedSubTitle3: ' para reactivarlo.',
    },
    terms: {
      title: 'Términos de Servicio',
      lastUpdate: 'Última actualización: 1 de agosto de 2024',
      button: 'Crear Código QR',
    },
    popup: {
      qrDelete: 'Eliminación de QR',
      qrDeleteSubtitle: 'Los códigos QR seleccionados serán eliminados. ¿Estás seguro?',
      leaveWithoutSaving: '¿Salir sin guardar?',
      youHaveUnsavedChanges:
        'Tienes cambios sin guardar. Si sales ahora, perderás tu progreso. ¿Estás seguro de que deseas salir de esta página?',
      stayOnPage: 'Permanecer en la página',
      leaveAnyway: 'Salir de todos modos',
      accountDelete: 'Eliminación de cuenta',
      accountDeleteSubtitle: 'Todos tus datos serán destruidos sin posibilidad de recuperación. ¿Estás seguro?',
      emailUnsubscribe: 'Darse de baja de los correos electrónicos',
      emailSubscribe: 'Suscribirse a los correos electrónicos',
      emailUnsubscribeSubtitle: 'Dejarás de recibir correos electrónicos. ¿Estás seguro?',
      emailSubscribeSubtitle:
        'Comenzarás a recibir correos electrónicos con actualizaciones importantes e información sobre tu cuenta. ¿Estás seguro?',
    },
    landing: {
      topTitle: 'Crea códigos QR gratis al instante',
      topSubTitle: 'Personaliza tus códigos QR con colores, formas y logotipos en solo 3 sencillos pasos.',
      topFirstBlockTitle: 'Elige el contenido de tu código QR',
      topFirstBlockSubTitle:
        'Crea códigos QR para cualquier cosa: sitios web, PDFs, imágenes, enlaces, vCards y más. Personalízalo para adaptarlo a tus necesidades.',
      topSecondBlockTitle: 'Personaliza el diseño de tu código QR',
      topSecondBlockSubTitle: 'Agrega tus detalles y usa nuestro generador para crear un código QR único para ti.',
      topThirdBlockTitle: 'Descarga tu código QR',
      topThirdBlockSubTitle:
        'Guarda tu código QR en formatos PDF, PNG o SVG. ¡Imprímelo o compártelo digitalmente, de forma rápida y sencilla!',
      sliderTitle: 'Genera diferentes tipos de Códigos QR',
      sliderTopTitle:
        'Los códigos QR pueden contener una gran cantidad de contenido y en QRBrain, los ofrecemos todos.',
      benefitTitle: 'QR-Brain marca la diferencia',
      benefitSubTitle:
        '#1 generador de códigos QR en el mercado, la herramienta indispensable para pequeñas y grandes empresas, crea códigos QR personalizados con tu logo, color y diseño, pruébalo durante 7 días completamente gratis.',
      benefitPoints: {
        0: 'Códigos QR ilimitados',
        1: 'Escaneos sin límites',
        2: 'Monitoreo completo',
        3: 'Etiqueta blanca (CNAME)',
      },
      benefitEnd: '¡...y muchos más!',
      anonymQr: {
        website: {
          title: 'Agregar URL del sitio web y diseñar tu código',
        },
        pdf: {
          title: 'PDF',
        },
        listOfLinks: {
          title: 'Lista de enlaces',
        },
        vCard: {
          title: 'Completa el contenido',
        },
        images: {
          title: 'Imágenes',
        },
        social: {
          title: 'Redes sociales',
        },
        apps: {
          title: 'Aplicaciones',
        },
        more: {
          title: 'Más tipos pronto',
        },
        selectQrType: 'Selecciona un tipo de QR',
        designYourCode: 'Diseña tu código',
      },
      qrCodeStarted: 'Códigos QR creados',
      globalTrustUs: 'Empresas globales confían en nosotros',
      ratedOnGoogle: 'Valorado en Google',
      featuresList: {
        staticQrName: 'QRs Estáticos',
        staticQrDescription: 'Códigos QR sin fecha de expiración',

        editingManagementName: 'Edición y gestión de QRs',
        editingManagementDescription: 'Códigos QR que permiten actualizaciones en tiempo real',

        eventTrackingName: 'Seguimiento de eventos',
        eventTrackingDescription: 'Una herramienta útil para hacer un seguimiento de las interacciones con los QR.',

        templatesName: 'Plantillas',
        templatesDescription: 'Guarda y reutiliza tus propios diseños',

        personalizationName: 'Edición y gestión de QRs',
        personalizationDescription: 'Personaliza y organiza tus códigos QR',

        downloadFormatsName: 'Variedad de formatos de descarga',
        downloadFormatsDescription: 'Amplía los posibles usos de tu código QR',

        completeAnalyticsName: 'Análisis completos',
        completeAnalyticsDescription: 'Obtén información detallada sobre el rendimiento',

        customDomainName: 'Dominio personalizado',
        customDomainDescription: 'Mejora tu marca con un dominio personalizado',

        unlimitedUsersName: 'Usuarios colaboradores ilimitados',
        unlimitedUsersDescription: 'Colabora en la gestión de tus códigos QR',

        passwordProtectionName: 'Acceso y protección con contraseña',
        passwordProtectionDescription: 'Asegura la privacidad de los datos para acceso autorizado',

        bulkCreationName: 'Creación y descarga masiva',
        bulkCreationDescription: 'Mejora la evaluación de tu campaña digital.',

        pixelIntegrationName: 'Integración de píxeles de Google y Facebook',
        pixelIntegrationDescription: 'Mejora la evaluación de tu campaña digital.',
      },
      benefitBlocks: {
        block0: {
          title: 'Códigos QR Dinámicos y Estáticos',
          subtitle:
            'Diseña y gestiona tanto Códigos QR Dinámicos como Estáticos con facilidad. ¡Ajusta la información de tu QR Dinámico incluso después de su creación! Conéctate en tiempo real con tu audiencia y actualiza el contenido al instante sin necesidad de reimprimir. ¡Olvídate de las limitaciones, te ofrecemos total flexibilidad!',
        },
        block1: {
          title: 'Múltiples páginas de destino',
          subtitle:
            '¡Descubre un universo de opciones con nuestras páginas de aterrizaje! Puedes seleccionar entre PDF, vCard, imágenes, lista de enlaces y mucho más. Adapta tu mensaje para diferentes audiencias y no te preocupes por el acceso a tu contenido. Nuestros servidores te garantizarán una experiencia sin interrupciones.',
        },
        block2: {
          title: 'Estadísticas completas',
          subtitle:
            'Datos estratégicos a tu alcance. Desde escaneos totales hasta clics en enlaces, nuestras estadísticas ofrecen una visión detallada de la interacción con tus QRs. Conoce los sistemas operativos, países y navegadores preferidos para adaptar tu estrategia con precisión. ¡Sigue tu éxito con nuestras estadísticas completas!',
        },
        block3: {
          title: 'Personaliza tu QR',
          subtitle:
            '¡Eleva tu presencia con un toque único! Personaliza tu QR con logos, colores y formas para destacar y aumentar las posibilidades de escaneo. Refleja tu identidad y fortalece el reconocimiento de marca con una estética atractiva. ¡Destácate de la multitud con QRs cautivadores!',
        },
      },
      faq: {
        title: 'Todo lo que necesitas saber para empezar',
        subTitle:
          'En esta sección encontrarás los conceptos básicos y los pasos necesarios para comenzar a disfrutar de los beneficios de usar QR.',
        boxes: {
          0: {
            title: '¿Qué es el código QR?',
            text: 'El término "QR" significa "respuesta rápida" y se refiere al acceso instantáneo a la información contenida en el Código. Es, en resumen, la evolución del código de barras, compuesto por patrones de píxeles en blanco y negro. Denso Wave, una subsidiaria japonesa de Toyota Denso, los desarrolló con el fin de marcar los componentes de sus coches y así acelerar la logística en su producción. Actualmente, ha ganado gran popularidad, debido a su versatilidad y accesibilidad, gracias a las funciones de los teléfonos inteligentes.',
          },
          1: {
            title: 'Conoce los beneficios de usar QR',
            text: `Probablemente hayas notado que cada vez más empresas están incorporando códigos QR como un recurso clave para el marketing y la promoción de sus productos y servicios. Su creciente popularidad se debe a la amplia gama de aplicaciones que ofrecen: facilitar pagos a los clientes, compartir enlaces a sitios web, catálogos y listas de precios, recopilar comentarios sobre productos o servicios, alentar a los clientes a compartir imágenes o videos, promocionar eventos comerciales y mucho más, ¡todo con solo un simple escaneo!`,
          },
          2: {
            title: 'Cómo empezar a usar QR',
            text: `Muchos dispositivos ya vienen con un lector de códigos QR integrado. Para usarlo, simplemente abre la cámara de tu teléfono móvil y manténla sobre el código durante unos segundos hasta que aparezca una notificación en la pantalla. Si esto no sucede, revisa la configuración para asegurarte de que la función de escaneo de QR esté habilitada. Si tu dispositivo no tiene esta función, puedes descargar e instalar fácilmente un lector de códigos QR desde tu tienda de aplicaciones.`,
          },
        },
      },
      questions: {
        title: 'No te quedes con dudas',
        secondTitle: '¿Quieres saber más?',
        description:
          'Consulta nuestras Preguntas Frecuentes para encontrar respuesta a cualquier duda que puedas tener sobre nuestros códigos QR.',
        button: 'Resuelve todas tus dudas',
        tabs: {
          basic: 'Información básica',
          design: 'Diseño y creación',
          scan: 'Escaneo e impresión',
        },
        boxesBasic: {
          0: {
            title: '¿Qué significa la generación de QR?',
            text: 'Es una herramienta que te permite crear diversos tipos de códigos QR de manera fácil e intuitiva. Con la creciente popularidad de los códigos QR, nuestro generador se ha convertido en un recurso fundamental para personas y empresas por igual. Puede ser utilizado por empresas de todo tipo para crear códigos QR para sitios web, compartir PDFs, galerías de fotos, listas de reproducción, listas de precios o menús, conectar a los clientes con servicios ofrecidos por tu empresa (como acceso a WiFi, citas, pagos, etc.), promocionar eventos con enlaces a tráileres, crear vCards con información de contacto para compartir con clientes, y mucho más.',
          },
          1: {
            title: '¿Puedo crear una cuenta para generar códigos QR gratis?',
            text: 'Absolutamente, los primeros siete días corren por nuestra cuenta, permitiéndote probar nuestro generador de códigos QR de manera gratuita.',
          },
          2: {
            title: '¿Los códigos QR están disponibles de forma gratuita?',
            text: 'Nuestro generador de códigos QR ofrece una prueba gratuita de siete días, lo que te permite crear y mantener códigos QR de manera permanente. Si estás satisfecho con el servicio, puedes elegir un plan que se adapte a tus necesidades. Con una suscripción, tendrás acceso ilimitado a todas las funciones: crear códigos QR dinámicos y editables ilimitados, explorar diversos tipos de QR, gestionar y editar tus QRs, rastrear escaneos ilimitados, ver análisis completos, y descargar en múltiples formatos.',
          },
          3: {
            title: '¿Por qué otros servicios permiten la creación de códigos QR de forma gratuita?',
            text: 'Esto se debe a que nuestros códigos QR son dinámicos en lugar de estáticos. Todos los códigos QR generados con QRBrain alojan información en nuestros servidores, como documentos PDF, videos e imágenes, lo que incurre en un costo. Por lo tanto, no son gratuitos.',
          },
          4: {
            title: '¿Pueden los QRs generados ser utilizados con fines comerciales?',
            text: 'Los códigos QR se han convertido en una parte integral de las estrategias de marketing de muchas empresas. No dudes en usar los códigos que generes en nuestra plataforma para renovar, mejorar la visibilidad y agregar dinamismo a tu negocio.',
          },
          5: {
            title: '¿Qué tipos de información se pueden almacenar en un QR?',
            text: 'Los códigos QR pueden contener una amplia gama de información adaptada a tus necesidades. Al escanear, los usuarios pueden ser dirigidos a diversos tipos de contenido, como sitios web, PDFs, galerías de fotos, listas de reproducción, listas de precios, menús, soporte técnico, redes WiFi, horarios de turnos, enlaces de pago, videos, datos de contacto, y más. Las posibilidades son infinitas.',
          },
          6: {
            title: '¿Puedo gestionar los códigos usando el generador de códigos QR?',
            text: 'Absolutamente. Una vez que te hayas suscrito a uno de nuestros planes, podrás gestionar tus códigos QR como desees: crear, diseñar, guardar, eliminar o modificar, agregar logos y marcos, generar un dominio, guardar tus diseños favoritos, editar URLs, y más.',
          },
          7: {
            title: '¿Cuánto tiempo son válidos los códigos QR? ¿Tienen fecha de caducidad?',
            text: 'Los códigos QR no caducan; siguen siendo funcionales a menos que cambies o elimines el enlace al que apuntan. Sin embargo, con los códigos QR dinámicos, puedes actualizar el contenido o los enlaces según sea necesario.',
          },
          8: {
            title: '¿Los códigos QR vienen con un contador de escaneos?',
            text: 'Sí. Con un plan de suscripción, puedes monitorear el número de escaneos que reciben tus códigos QR. Esto te permite rastrear el rendimiento de tu campaña y hacer ajustes para mejorar o expandir tus esfuerzos.',
          },
        },
        boxesDesign: {
          0: {
            title: '¿Puedo modificar o actualizar un código QR?',
            text: 'Nuestro servicio te permite ajustar el contenido, corregir errores o actualizar el enlace de un código QR incluso después de haber sido creado. Entendemos que pueden ocurrir errores o cambios, por lo que ofrecemos la opción de editar tus códigos QR sin necesidad de generar uno nuevo. Simplemente ve a la sección "Mis Códigos QR", selecciona el código QR que deseas modificar y realiza los cambios necesarios tantas veces como sea necesario, aunque cambiar el tipo de diseño requerirá la creación de un nuevo código QR.',
          },
          1: {
            title: '¿Puedo agregar el isotipo o logo de mi empresa a un código QR?',
            text: '¡Absolutamente! Agregar el isotipo o logo de tu empresa al código QR mejora su atractivo y refuerza la visibilidad de tu marca. Puedes usar nuestra prueba gratuita de siete días para explorar esta función en nuestro generador de códigos QR.',
          },
          2: {
            title: '¿Puedo crear códigos QR en color, o solo están disponibles en blanco y negro?',
            text: '¡Puedes seleccionar los colores que desees! Nuestro creador de códigos QR te permite elegir entre un amplio espectro de opciones de color #RRGGBB. Puedes usar los colores de tu empresa, coincidir con la estética de tu campaña o dejar fluir tu creatividad combinando colores como desees.',
          },
          3: {
            title: '¿Es posible crear múltiples códigos QR para el mismo contenido?',
            text: '¡Por supuesto! Puedes crear hasta 40 versiones distintas de un código QR para el mismo contenido, con opciones para cuatro niveles de corrección de errores y ocho niveles de enmascaramiento. Nuestro generador de códigos QR seleccionará la versión óptima en función de la cantidad de datos y la legibilidad para garantizar la imagen de mayor calidad. Además, puedes personalizar estas diferentes versiones usando nuestra herramienta de diseño.',
          },
        },
        boxesScan: {
          0: {
            title: '¿Cómo puedo escanear o leer un código QR con mi smartphone?',
            text: 'La mayoría de los dispositivos iPhone y Android vienen con un lector de códigos QR incorporado. Para usarlo, simplemente abre la aplicación de cámara y apunta hacia el código QR. Mantenlo allí durante unos segundos hasta que aparezca una notificación en tu pantalla. Si la notificación no aparece, verifica la configuración para asegurarte de que la lectura de QR esté habilitada. Si tu dispositivo no tiene esta función, puedes descargar un lector de códigos QR desde tu tienda de aplicaciones, muchos de los cuales son gratuitos.',
          },
          1: {
            title: '¿Existen límites en la cantidad de escaneos para los códigos QR?',
            text: 'No, los códigos QR se pueden escanear tantas veces como sea necesario.',
          },
          2: {
            title: '¿Por qué no funciona mi código QR?',
            text: 'Podría haber varias razones para este problema. El código QR podría estar borroso o el escáner podría tener dificultades para detectarlo si no hay suficiente contraste entre el código y el fondo. Asegúrate de que el color del primer plano sea siempre más oscuro que el del fondo. Si sigues experimentando problemas, no dudes en contactarnos.',
          },
          3: {
            title: '¿Qué pasos debo seguir antes de imprimir mi código QR?',
            text: 'Para evitar errores costosos en tu campaña de marketing, asegúrate de verificar la funcionalidad de tu código QR antes de imprimir. Asegúrate de que los colores tengan suficiente contraste para una legibilidad óptima, con el primer plano siendo más oscuro que el fondo. Verifica que la información incrustada en tu código QR (como URLs, direcciones de correo electrónico, texto o mapas) sea precisa. Prueba el código QR escaneándolo con dispositivos que utilicen diferentes sistemas operativos. Además, confirma que el propósito o función del código QR sea claro en su presentación, para que tus clientes entiendan por qué necesitan escanearlo.',
          },
          4: {
            title: '¿En qué formatos gráficos se pueden crear los códigos QR?',
            text: 'Una vez que te registres en nuestro sitio, podrás descargar tus códigos en múltiples formatos: JPG, PNG y SVG de alta resolución.',
          },
        },
      },
      footer: {
        generateTitle: 'Genera códigos QR personalizados que cuenten tu historia',
        title: 'Prueba nuestro generador de códigos QR gratis durante 7 días.',
        createBtn: 'Crear código QR',
        logoDesc: 'Crea códigos QR personalizados para elevar tu negocio o idea.',
        copy: 'Generador de Códigos QR - “Código QR” es una marca registrada de DENSO WAVE INCORPORATED',
        desc: `Crea códigos QR personalizados para elevar tu negocio o idea.`,
        company: 'Empresa',
        pricePlan: 'Planes y precios',
        tos: 'Términos de Servicio',
        privacy: 'Política de Privacidad',
        dataDeletion: 'Eliminación de Cuenta',
        qrCode: 'Códigos QR',
        website: 'Sitio web',
        pdf: 'PDF',
        vcard: 'vCard Plus',
        images: 'Imágenes',
        lol: 'Lista de enlaces',
        social: 'Redes Sociales',
        apps: 'Aplicaciones',
        help: 'Ayuda',
        contact: 'Contáctanos',
        faq: 'Preguntas frecuentes',
      },
      createQr: {
        titleLeft: 'Obtén tu código QR en',
        titleRight: '30 segundos',
      },

      howToCreateQr: {
        title: '¿Cómo crear un código QR?',
        step1: {
          title: 'Elige el contenido de tu código QR',
          text: 'Crea códigos QR para cualquier cosa: sitios web, PDFs, imágenes, enlaces, vCards y más. Adáptalo a tus necesidades.',
        },
        step2: {
          title: 'Personaliza y diseña tu código QR',
          text: 'Agrega tus detalles y utiliza nuestro generador para crear un código QR que sea único para ti.',
        },
        step3: {
          title: 'Descarga tu código y compártelo',
          text: 'Guarda tu código QR en formatos PDF, PNG o SVG. Imprímelo o compártelo digitalmente: ¡rápido y fácil!',
        },
      },
      tryQrCode: {
        title: 'Prueba nuestro generador de códigos QR durante 7 días gratis.',
      },
      createFreeAccount: 'Crear cuenta gratis',
      features: {
        title: 'Códigos QR que',
        otherServices: 'Otros servicios',
        makeYouLookSmart: 'Te hacen lucir inteligente',
      },
      designYourCode: {
        title: 'Diseña tu código QR perfecto ahora',
        generate:
          'Genera códigos QR de alta calidad optimizados para cualquier superficie o pantalla. Descárgalos en múltiples formatos y personaliza tus códigos cuando lo necesites.',
      },
      possibilities: {
        titleLeft: 'Con QR Creator',
        titleRight: 'las posibilidades son infinitas',
        chooseType: 'Elige tipo de QR',
        createQrCode: 'Crear código QR',
        website: {
          connect:
            'Conecta tu URL a un código QR para que todos puedan acceder a tu sitio web de forma rápida y fácil. ¡Convierte cada visita en una oportunidad de crecimiento!',
          provides:
            'Proporciona acceso rápido a tu sitio web o tienda en línea con un simple escaneo, optimizando la experiencia de los usuarios y potenciales clientes.',
          update:
            'Actualiza el enlace tantas veces como necesites sin tener que modificar el código QR impreso, siempre asegurando contenido relevante.',
        },
        pdf: {
          from: 'Desde menús hasta guías de usuario y portafolios creativos, da a tus clientes acceso a documentos PDF de manera rápida y eficiente.',
          customize:
            'Personaliza tu código QR para reflejar tu marca, haciendo que el acceso a tus documentos sea atractivo.',
          adjust:
            'Ajusta el contenido de tus documentos en cualquier momento, asegurando que tus clientes siempre tengan acceso a la versión más reciente.',
        },
        links: {
          share:
            'Comparte enlaces a tu sitio web, tienda en línea, portafolio y perfiles de redes sociales a través de un único código QR de lista de enlaces.',
          make: 'Facilita que tus clientes encuentren rápidamente lo que buscan centralizando toda tu información importante en un solo lugar.',
          allows:
            'Permite que los usuarios compartan fácilmente tus enlaces con otros, ampliando tu alcance y conectando con una audiencia más amplia.',
        },
        vcard: {
          transform:
            'Transforma tu tarjeta de presentación en una experiencia digital interactiva, donde tus contactos pueden acceder a toda tu información y redes sociales con solo un escaneo.',
          customize:
            'Personaliza tu vCard para reflejar tu identidad profesional, añadiendo tu foto, ubicación y enlaces a tus redes sociales para una presentación más completa.',
          make: 'Facilita que tus contactos guarden tus detalles en su dispositivo con un solo clic, eliminando la necesidad de ingresar la información manualmente.',
        },
        images: {
          share:
            'Comparte recuerdos y momentos especiales como nunca antes a través de un código QR, donde cada imagen cuenta una historia y es accesible para todos.',
          showcase:
            'Muestra tus mejores fotos de productos o eventos con un solo escaneo, atrayendo a posibles clientes con contenido visual atractivo y accesible.',
          update:
            'Actualiza tu galería con imágenes de nuevos lanzamientos, proyectos recientes o destacados para mantener a tu audiencia comprometida.',
        },
        social: {
          simplify:
            'Simplifica cómo los usuarios interactúan con tus perfiles de redes sociales utilizando códigos QR. Conecta instantáneamente a tu audiencia con tus cuentas, facilitando que sigan, den me gusta e interactúen con tu contenido.',
          with: 'Con un solo escaneo, los usuarios pueden acceder a tus perfiles de redes sociales, eliminando la necesidad de búsquedas manuales y asegurando una interacción rápida.',
          update:
            'Actualiza tus enlaces de redes sociales o información en cualquier momento, asegurando que tu audiencia siempre tenga el contenido más relevante y actualizado.',
        },
        apps: {
          simplify:
            'Simplifica la forma en que los usuarios acceden a tu aplicación con códigos QR diseñados para una conectividad sin problemas. Ya sea dirigiéndolos a enlaces de descarga, actualizaciones de aplicaciones o características específicas, los códigos QR facilitan la conexión.',
          enable:
            'Permite que los usuarios accedan instantáneamente a tu aplicación o características clave de la aplicación con un solo escaneo, ahorrando tiempo y mejorando la experiencia del usuario.',
          update:
            'Actualiza la información de la aplicación o los enlaces de redirección según sea necesario, asegurando que los usuarios siempre reciban el contenido más relevante y actualizado.',
        },
        coupon: {
          description:
            'Impulsa las ventas y la fidelidad de los clientes con códigos QR de cupones fáciles de escanear. Entrega al instante descuentos y ofertas especiales a tus clientes, facilitándoles el ahorro mientras aumentas tus tasas de conversión.',
          feature1:
            'Con un solo escaneo, los clientes pueden acceder a tus ofertas y promociones exclusivas, eliminando la necesidad de cupones impresos y asegurando una redención sin complicaciones.',
          feature2:
            'Actualiza tus ofertas de cupones o los porcentajes de descuento en cualquier momento, asegurando que tus clientes siempre tengan acceso a tus promociones más recientes y atractivas.',
        },
        video: {
          description:
            'Mejora el compromiso con contenido de video dinámico mediante códigos QR. Conecta al instante a tu audiencia con tus videos, facilitando que vean tutoriales, testimonios o contenido promocional sin tener que escribir URLs largas.',
          feature1:
            'Con un solo escaneo, los usuarios pueden acceder a tu contenido en video, eliminando la necesidad de búsquedas manuales y asegurando una experiencia de visualización inmediata.',
          feature2:
            'Actualiza tus enlaces o contenido de video en cualquier momento, asegurando que tu audiencia siempre tenga acceso a tu material audiovisual más reciente y relevante.',
        },
      },
      benefits: {
        headerTitle: 'NUESTROS BENEFICIOS',
        title: 'QR Brain marca la diferencia',
        rates: {
          title: 'Altas tasas de conversión',
          description:
            'Crea códigos QR de alto rendimiento que representen con precisión tu marca y diseño, resultando en altas tasas de escaneo.',
        },
        qrs: {
          title: 'QRs Dinámicos y Estáticos',
          description:
            'Diseña y gestiona códigos QR tanto Dinámicos como Estáticos con facilidad. Ajusta la información de tu QR Dinámico incluso después de su creación. Conéctate en tiempo real con tu audiencia y actualiza contenido al instante sin necesidad de reimprimir. ¡Olvídate de las limitaciones, te ofrecemos total flexibilidad!',
        },
        notes: {
          title: 'Múltiples páginas de destino',
          description:
            '¡Descubre un universo de opciones con nuestras páginas de destino! Puedes elegir entre PDF, vCard, Imágenes, Lista de enlaces y mucho más. Adapta tu mensaje a diferentes audiencias y no te preocupes por el acceso a tu contenido. Nuestros servidores te garantizarán una experiencia sin problemas.',
        },
        statistics: {
          title: 'Estadísticas completas',
          description:
            'Datos estratégicos al alcance de tu mano. Desde escaneos totales hasta clics en enlaces, nuestras estadísticas ofrecen una vista detallada de la interacción con tus QRs. Conoce los sistemas operativos, países y navegadores preferidos para adaptar tu estrategia de manera precisa. ¡Sigue tu éxito con nuestras estadísticas completas!',
        },
        customization: {
          title: 'Personaliza tu QR',
          description:
            '¡Eleva tu presencia con un toque único! Personaliza tu QR con logotipos, colores y formas para destacar e incrementar las posibilidades de escaneo. Refleja tu identidad y fortalece el reconocimiento de tu marca con una estética atractiva. ¡Destácate con QRs cautivadores!',
        },
        download: {
          title: 'Descarga, comparte y edita fácilmente',
          description:
            'Mantén la resolución más alta para tus códigos QR, sin importar el medio en el que los imprimas o muestres. Descárgalos en JPG, PNG o SVG y edita su contenido en cualquier momento.',
        },
      },
      createQRToday: {
        title: '¡Crea tus códigos QR hoy!',
        description:
          'Regístrate para una prueba gratuita y comienza a generar tus códigos QR dinámicos personalizables. Optimiza el rendimiento con análisis avanzados y características de marca, y edita tus códigos QR en cualquier momento.',
      },
      qrsOn: {
        headerTitle: 'QR CODES EN',
        title: 'Nuestros QRs en el mundo real.',
        bottles: 'Botellas y latas',
        businessCards: 'Tarjetas de presentación',
        pamphlets: 'Folletos',
        brochures: 'Folleto',
        productPacking: 'Embalaje de productos',
        menu: 'Menú',
      },
      reviews: {
        headerTitle: 'Reseñas',
        title: 'Lo que nuestros clientes aman de QR Brain',
        description: 'a través de sus reseñas en',
      },
      faqBlock: {
        title: 'Obtén respuestas a tus preguntas',
        link: 'Ver todas las preguntas frecuentes',
      },
    },

    landingSliderTitles: {
      website:
        'Lleva tu tarjeta de presentación al siguiente nivel con un código QR. Comparte más información sobre tu perfil y tu empresa de una manera innovadora y única. Y lo mejor de todo, cambia la información en el código QR cuando lo necesites.',
      pdf: 'Comparte archivos PDF usando un código QR. Formularios, información y textos disponibles para cualquiera de manera rápida y segura.',
      vCard:
        'Lleva tu tarjeta de presentación al siguiente nivel con un código QR. Comparte más información sobre tu perfil y tu empresa de una manera innovadora y única. Y lo mejor de todo, cambia la información en el código QR cuando lo necesites.',
      images:
        'Comparte imágenes y fotos como nunca antes a través de un código QR. ¿Quién iba a imaginar que tantos recuerdos podrían estar en un solo código QR?',
      listOfLinks:
        'Reúne en enlaces el contenido más relevante para compartir con tu audiencia y ayuda a tus seguidores a encontrarte en las redes sociales con un solo escaneo de QR.',
      social:
        'Facilita el acceso a tus redes sociales: comparte todos tus perfiles con este QR y permite que tu audiencia siempre esté al día con tus publicaciones y contenido.',
      apps: 'Facilita a los usuarios la descarga e instalación de tu aplicación con un código QR. Ahorra tiempo en la búsqueda y genera una experiencia positiva para el usuario.',
    },
    landingSliderButtons: {
      website: 'Crear código QR para Sitio web',
      pdf: 'Crear código QR para PDF',
      vCard: 'Crear código QR para Imágenes',
      images: 'Crear código QR para Imágenes',
      listOfLinks: 'Crear código QR para Lista de enlaces',
      social: 'Crear código QR para APPS',
      apps: 'Crear código QR para APPS',
    },
    faq: {
      title0: '¿Cómo funciona la facturación?',
      title1: '¿Qué sucede si quiero hacer cambios en algún Código QR?',
      title2: '¿Hay una prueba gratuita?',
      title3: '¿Cuánto tiempo tomará hasta que obtenga mis códigos QR?',
      title4: '¿Cuáles son los requisitos para obtener mis códigos QR?',
      title5: '¿Puedo cambiar mi plan?',
      title6: '¿Cuáles son mis opciones de pago?',
      title7: '¿Puedo usar los códigos QR generados durante el período de prueba para fines comerciales?',
      title8: '¿Qué sucede con mis códigos QR una vez que finaliza el período de prueba?',
      title9: '¿Debo cancelar el período de prueba si no voy a continuar usando la plataforma?',
      title10: '¿Qué tipo de acceso me da el período de prueba?',
      title11: '¿Ofrecen reembolsos por períodos de suscripción no utilizados?',
      title12: '¿Qué sucede con mis códigos QR si se cancela mi suscripción?',
      subTitle0:
        'Comienza a usar nuestras funciones premium obteniendo una prueba gratuita de 7 días. La prueba te da acceso a todas nuestras funciones premium durante 7 días. Si durante estos 7 días decides que te gusta el servicio, puedes proceder y elegir un plan.',
      subTitle1: 'Puedes editar tu Código QR tanto como quieras en tu panel de control.',
      subTitle2:
        'Absolutamente, la prueba gratuita dura 7 días y puedes crear Códigos QR dinámicos y estáticos. Los Códigos QR estáticos seguirán funcionando después de que expire la prueba gratuita.',
      subTitle3:
        'Tan pronto como pagues por el producto, tus Códigos QR personalizados ya estarán creados en tu panel de control. ¡El proceso toma menos de un minuto!',
      subTitle4:
        'Necesitaremos que nos digas un par de cosas como qué Color y Forma deseas para tu Código QR, qué tipo de Código QR, y alguna otra información que nos permita crear un Código QR conforme para ti.',
      subTitle5:
        'Sí, puedes mejorar, degradar o cancelar tu plan en cualquier momento desde el panel de control o visitando https://qrbrain.io/cancel-subscription. Si necesitas ayuda para cambiar tu cuenta, contáctanos a través de nuestro correo electrónico (support@qrbrain.io).',
      subTitle6:
        '¡Puedes pagar con tarjeta de crédito o con cualquier tarjeta de débito que desees! Todos nuestros pagos están asegurados por Stripe.',
      subTitle7: 'Sí',
      subTitle8:
        'Tus códigos QR serán almacenados durante tres meses después de que finalice el período de prueba. Durante este período no podrás acceder a ellos hasta que contrates uno de nuestros planes.',
      subTitle9:
        'No. El período de prueba gratuito finaliza automáticamente después de 7 días. Solo los planes de pago pueden ser cancelados.',
      subTitle10:
        'Nuestro período de prueba te da acceso a todas nuestras herramientas. En QRBrain.io, creemos que para evaluar un servicio, debes poder probarlo por completo.',
      subTitle11:
        'No se ofrecen reembolsos por períodos de suscripción no utilizados. Los usuarios pueden evitar que la suscripción se renueve automáticamente cancelándola en cualquier momento.',
      subTitle12:
        'Tus códigos QR no desaparecerán, pero no podrás acceder a ellos ni a los datos recopilados hasta que actualices tu plan. Tus códigos QR solo desaparecerán si eliminas tu cuenta de QRBrain.io.',
      title: 'FAQs',
      date: 'Si tienes alguna pregunta que no puedes responder a través de nuestras preguntas frecuentes, no dudes en contactar con nuestro equipo.',
    },
    plansAndPrices: {
      title: 'Plans & Pricing',
      subTitle: 'Pruébalo durante 7 días gratis antes de suscribirte al plan que mejor se adapte a tus necesidades.',
      billedAnnually: 'Facturado anualmente',
      billedSemiAnnually: 'Facturado cada semestre',
      billedQuarterly: 'Facturado trimestralmente',
      buy: 'Comprar',
      bottomTitle: 'Impuesto al Valor Agregado no incluido en los montos.',
      paymentsTitle: 'Métodos de pago',
      allPlans: 'Todos los planes incluyen:',
      month: 'mes',
      months: '{months} meses',
      faq: {
        title: 'Preguntas sobre los planes',
        changePlan: {
          summary: '¿Puedo cambiar mi plan?',
          details:
            'Una vez que te suscribas a un plan, solo podrás hacer cambios un mes antes de que termine tu suscripción actual. Ten en cuenta que puedes cancelar tu plan en cualquier momento. Si tienes preguntas, contáctanos a través de este enlace.',
        },
        offerRefunds: {
          summary: '¿Ofrecen reembolsos por períodos de suscripción no utilizados?',
          details:
            'No se ofrecen reembolsos por períodos de suscripción no utilizados. Los usuarios pueden evitar que la suscripción se renueve automáticamente cancelándola en cualquier momento.',
        },
        fullAccess: {
          summary: '¿Tengo acceso completo con cualquier plan?',
          details:
            'Sí. Con cualquier plan tendrás acceso total a las herramientas para crear códigos QR, estadísticas y formatos de descarga.',
        },
        free: {
          summary: '¿Puedo probarlo gratis?',
          details: 'Por supuesto, tienes 7 días gratis para probar la aplicación antes de elegir un plan de pago.',
        },
        paymentMethods: {
          summary: '¿Qué métodos de pago aceptan?',
          details:
            'Aceptamos pagos con tarjeta (Mastercard, Visa). Todos los pagos se realizarán en la moneda seleccionada, y los precios no incluyen el impuesto al valor agregado.',
        },
        cancel: {
          summary: '¿Cómo puedo cancelar mi suscripción?',
          details:
            'Puedes cancelar la suscripción cuando lo desees sin compromiso desde la sección de facturación en tu cuenta.',
        },
      },
    },
    privacy: {
      title: 'Política de Privacidad de QRBrain',
      lastUpdate: 'Última actualización: 1 de agosto de 2024',
      text: {
        0: 'Esta Política de Privacidad describe cómo recopilamos, utilizamos y compartimos los datos personales de las personas que usan o están conectadas a nuestros servicios, que están interesadas en QRBrain o sus servicios, o a quienes deseamos comercializar nuestros servicios. Esta Política de Privacidad también le proporciona información sobre sus derechos como titular de los datos y cómo ponerse en contacto con nosotros si tiene alguna pregunta.',
        1: 'Esta Política de Privacidad no se aplica a las prácticas de otras empresas que QRBrain no posee ni controla, incluidos los sitios web, servicios y aplicaciones de otras compañías ("Servicios de Terceros") a los que puede acceder a través de los Servicios o a individuos que QRBrain no administra ni emplea. Le recomendamos que revise las políticas de privacidad de cualquier Servicio de Terceros que acceda o utilice. Tenga en cuenta que no podemos asumir responsabilidad por el contenido o las políticas de privacidad de los Servicios de Terceros, y cualquier política de terceros vinculada a esta Política de Privacidad es únicamente para fines informativos.',
        2: 'Tenga en cuenta que nuestras prácticas de privacidad están sujetas a las leyes aplicables de las regiones en las que operamos. En consecuencia, algunos términos adicionales específicos de la región solo se aplicarán a las personas en esos lugares, o según lo exijan las leyes aplicables. Si es residente de California, Virginia, Colorado, Connecticut u otros estados de EE. UU., consulte las secciones tituladas Derechos de Privacidad en California, y Derechos de Privacidad en Virginia/Colorado/Connecticut y ciertos otros estados de EE. UU. para obtener divulgaciones específicas sobre nuestra recopilación, uso y divulgación de su información y los derechos adicionales que tiene bajo las leyes aplicables de EE. UU.',
      },
      contactInfo: {
        title: 'Información de Contacto',
        0: 'Esta Política de Privacidad describe las políticas y procedimientos de QRBrain, Calle Federica Montseny 18, 28049, Madrid (España) para la recopilación, uso y divulgación de datos personales sobre usted para los cuales cualquiera de nosotros actúa como controlador de datos, o para los cuales actuamos como controladores conjuntos, de acuerdo con el Reglamento General de Protección de Datos de la Unión Europea ("GDPR") y otras leyes aplicables.',
        1: 'Si tiene alguna pregunta o inquietud con respecto a la privacidad al usar los Servicios de QRBrain o desea ejercer sus derechos, como oponerse al procesamiento o que se eliminen sus datos personales, envíenos un mensaje detallado a: support@qrbrain.io. Haremos todo lo posible por resolver sus inquietudes. Consulte también "Derechos de los Sujetos de los Datos" para obtener más información detallada sobre sus derechos como titular de los datos.',
      },
      qrService: {
        title: 'Servicios de QRBrain',
        0: 'QRBrain recopila datos personales sobre usted de las siguientes fuentes, según se describe en esta Política de Privacidad, cuando (i) se registra en el Sitio y los Servicios, a través de su cuenta de usuario con QRBrain, incluido el registro a través de un servicio de terceros (su “Cuenta”); (ii) utiliza los Servicios; o (iii) visualiza o interactúa con un enlace de QRBrain, un código QR, un enlace en Bio. Recopilamos los siguientes tipos de información suya, algunos de los cuales pueden considerarse datos personales según la ley aplicable:',
        subtitle: 'Cuando Se Registra para una Cuenta de QRBrain',
        1: 'Cuando crea una Cuenta, recopilamos los datos personales de usted, como su nombre, número de teléfono, nombre de la empresa, industria, cargo, tamaño de la empresa, dirección de correo electrónico, número de teléfono e información de inicio de sesión. Si crea una Cuenta utilizando su información de inicio de sesión de una cuenta de terceros, como Google, Facebook, Apple, LinkedIn o X, accederemos y recopilaremos los datos personales sobre usted que la cuenta de terceros proporcione (según la configuración de privacidad que tenga con la cuenta de terceros), para que pueda iniciar sesión en su Cuenta con nosotros. Utilizamos su información de contacto para enviarle información sobre nuestros Servicios y comunicarnos con usted acerca de su Cuenta, sus actividades en nuestro Sitio y Servicios, y cambios en las políticas. Puede darse de baja para dejar de recibir ciertos tipos de estos mensajes a través de la configuración de su Cuenta, aunque QRBrain se reserva el derecho de contactarlo cuando lo consideremos necesario, como por motivos administrativos y de gestión de cuentas.',
        2: 'Podemos recibir una confirmación cuando abre un correo electrónico nuestro. Usamos esta confirmación para mejorar nuestro servicio al cliente. Tiene la oportunidad de agregar subusuarios a su Cuenta. Si crea un subusuario, se procesarán los siguientes datos personales del subusuario: Nombre, dirección de correo electrónico, dirección IP del dispositivo del usuario, fecha y hora de creación del subusuario, información de inicio de sesión, empleador, número de teléfono.',
        3: 'Algunas funciones de los Servicios permiten a los usuarios registrados proporcionar su propio contenido a los Servicios, como descripciones escritas de URL, comentarios, imágenes y videos. A menos que solicite la eliminación de sus datos personales según lo descrito en esta Política de Privacidad, todo el contenido que envíe a los Servicios puede ser retenido por QRBrain, incluso después de que termine su Cuenta y puede continuar siendo compartido por terceros, según se describe en esta Política de Privacidad.',
      },
      contract: {
        title: 'Contratos, Órdenes de Compra y Facturación',
        0: 'Para cualquier persona que actúe como el contacto para nuestros clientes, proveedores, socios u otras entidades con las que realizamos o deseamos realizar negocios, procesamos la siguiente información:',
        item: {
          0: 'Información básica (como nombre, título, nombre de la empresa, ubicación de trabajo e información de contacto)',
          1: 'Conexiones comerciales',
          2: 'Comunicaciones',
        },
        1: 'La persona que actúa como contacto es una fuente principal de información, pero los datos personales también pueden ser recopilados de sus empleados, colegas, y nuestros (otros) clientes, proveedores y socios. Los datos personales se utilizan para discutir negocios, buscar oportunidades comerciales, enviar notificaciones relacionadas con nuestros servicios y, de lo contrario, comunicarse con usted, así como para la contratación, facturación y realización de pagos. El procesamiento se basa en nuestros intereses legítimos para cumplir con obligaciones contractuales, o los términos de los acuerdos que tenemos (o hemos tenido), manteniendo relaciones y operando nuestro negocio. Además, los datos personales relacionados con la facturación se utilizarán en la contabilidad y los informes, cuyo procesamiento se basará en nuestras obligaciones legales.',
      },
      website: {
        title: 'Sitio Web y solicitudes de contacto',
        0: 'QRBrain procesa los datos personales recopilados cuando utiliza o accede a sus respectivos sitios web, incluidos todos los subdominios de los sitios (cada "Sitio", según corresponda). Cada vez que se accede al Sitio, nuestro sistema recopila automáticamente datos e información relevante del sistema informático del dispositivo que realiza la llamada.',
        1: 'Se recopilan los siguientes datos:',
        item: {
          0: 'Tipo de navegador y versión utilizada',
          1: 'El sistema operativo del usuario',
          2: 'El proveedor de servicios de Internet del usuario',
          3: 'La dirección IP del usuario',
          4: 'Fecha y hora de acceso',
          5: 'Páginas web desde las cuales el sistema del usuario accedió a nuestro sitio web',
          6: 'Páginas web a las que accedió el sistema del usuario a través de nuestro sitio web',
        },
        2: 'Estos datos se almacenan en los archivos de registro de nuestro sistema. Estos datos no se almacenan junto con otros datos personales del usuario. El almacenamiento temporal de la dirección IP por parte del sistema es necesario para la entrega del sitio web al ordenador del usuario. Para este propósito, la dirección IP del usuario debe mantenerse durante la sesión. El almacenamiento en archivos de registro se realiza para garantizar la funcionalidad del sitio web. Los datos también se utilizan para optimizar el sitio web y garantizar la seguridad de nuestros sistemas informáticos. No se realiza un análisis de estos datos con fines de marketing. La base legal para el almacenamiento temporal y el otro procesamiento descrito anteriormente de los datos y archivos de registro es nuestro interés legítimo en mantener la funcionalidad y garantizar la seguridad de nuestro sitio web.',
        3: 'Si se conecta con nosotros utilizando varias plataformas de redes sociales y/o redes profesionales, tenga en cuenta que QRBrain no controla ni influye en cómo esas plataformas procesan sus datos personales. Le recomendamos que se ponga en contacto con esas plataformas de terceros directamente para obtener información sobre su procesamiento. Aquí hay algunos enlaces para su conveniencia:',
        links: {
          0: {
            title: 'Twitter:',
            link: 'https://twitter.com/de/privacy',
          },
          1: {
            title: 'YouTube:',
            link: 'https://policies.google.com/privacy?gl=DE&hl=en',
          },
          2: {
            title: 'LinkedIn:',
            link: 'https://www.linkedin.com/legal/privacy-policy',
          },
        },
        4: 'QRBrain puede utilizar API de terceros y kits de desarrollo de software (“SDK”) para proporcionar ciertas funciones en nuestros Servicios. Utilizamos cookies y tecnologías similares para los siguientes propósitos: Técnicamente necesarias; Comodidad; Estadísticas; Marketing. Cuando utilizamos cookies y/o técnicas similares para procesar datos personales, los tipos de datos personales procesados pueden variar, dependiendo de las categorías de cookies o técnicas similares. Las cookies no esenciales se utilizan solo con su consentimiento. Tiene la opción de impedir que se guarden cookies en su dispositivo.',
        5: 'Consulte nuestra Política de Cookies y la Política de Cookies de la UE para obtener más información sobre cómo QRBrain y sus socios utilizan cookies o tecnologías similares para analizar tendencias, administrar el sitio web, rastrear los movimientos de los usuarios en el sitio web y recopilar información demográfica sobre nuestra base de usuarios.',
      },
      business: {
        title: 'Transferencias comerciales',
        0: 'Podemos transferir y/o proporcionar información sobre nuestros usuarios en relación con una adquisición, venta de activos de la empresa u otra situación en la que la información de los usuarios se transfiera como uno de nuestros activos comerciales. Se le notificará por correo electrónico y/o mediante un aviso destacado en nuestro sitio web. En tal caso, el adquirente de QRBrain puede continuar utilizando su información como se establece en esta política o según lo permita la ley.',
        subtitle1: 'Protección de QRBrain y otros',
        1: 'QRBrain puede acceder, leer, conservar y divulgar cualquier información que recopile cuando tenga una creencia de buena fe de que hacerlo es razonablemente necesario para (i) cumplir con una ley, regulación o solicitud legal obligatoria, incluida una orden judicial de una agencia gubernamental de aplicación de la ley o seguridad nacional; (ii) hacer cumplir esta Política de Privacidad o nuestros Términos de Servicio, incluida la investigación de posibles violaciones de los mismos; (iii) detectar, disuadir, prevenir o abordar de otra manera actividades maliciosas, fraudulentas o ilegales; (iv) responder a solicitudes de soporte del usuario; o (v) proteger los derechos, la propiedad o la seguridad de QRBrain, sus usuarios y el público. Esto incluye intercambiar información con otras empresas y organizaciones para proteger contra actividades maliciosas, fraudulentas o ilegales.',
        2: 'El período de limitación de los posibles pagos pendientes (deuda), el que ocurra más tarde según las leyes aplicables, ha pasado. Los datos de suscripción, datos de uso del producto y datos similares basados en las acciones de los usuarios se anonimizan o eliminan después de que hayan pasado tres (3) años desde el año en que se desactivó la cuenta.',
      },
      web: {
        title: 'Seguimiento web y estadísticas',
        0: 'Utilizamos soluciones de seguimiento web para mejorar continuamente el contenido y nuestro sitio desde un punto de vista técnico, de diseño y editorial, y para hacerlo más conveniente para usted. Basándonos en los hallazgos estadísticos sobre el tipo de navegador y el sistema operativo, podemos optimizar nuestro diseño web.',
        1: 'Al usar estos métodos, no obtenemos ningún dato personal sobre usted, sino solo información estadística sobre el uso de nuestros sitios web y productos. De esta manera, aprendemos, por ejemplo, qué contenido de nuestros sitios web es particularmente popular, en qué momentos se usa particularmente nuestro sitio web, a través de qué páginas nuestros usuarios acceden a nuestro sitio, desde dónde el usuario se conectó a Internet antes de visitar el sitio y qué navegadores y sistemas operativos suelen usar nuestros usuarios cuando navegan por nuestros sitios web. Utilizamos esta información para mejorar continuamente el contenido y nuestro sitio desde un punto de vista técnico, de diseño y editorial, y para hacerlo más conveniente para usted. Los datos recopilados se almacenan en una llamada sesión de seguimiento junto con una identificación de usuario anónima (hash único de las propiedades del navegador y la hora actual). Además, la recopilación y el procesamiento de datos se realiza en todo momento sin referencia personal. Las estadísticas se utilizan para habilitar y mejorar la funcionalidad y el rendimiento de nuestro sitio web y servicios, y para comprender el comportamiento del usuario y mejorar nuestro sitio web, servicios y experiencia del cliente. Los datos del píxel de seguimiento se almacenan en el dispositivo del usuario por hasta 12 meses.',
      },
      customer: {
        title: 'Soporte al cliente y gestión',
        0: 'QRBrain colabora para brindar servicios de soporte a nuestros clientes, y para administrar y gestionar las relaciones con los clientes mediante el uso y compartición de los siguientes datos personales:',
        item: {
          0: 'Información de cuenta, suscripciones a los Servicios, información de facturación y datos de pago,',
          1: 'Datos personales incluidos en la información comercial (si es cliente corporativo) e información contable,',
          2: 'Eventos de usuario, creación de cuenta, uso de productos y otros datos de uso (como registros, codificaciones, decodificaciones y vistas de página) de los Servicios,',
          3: 'Credenciales para el canal(es) de soporte al cliente y otras herramientas que podemos proporcionar,',
          4: 'Comunicaciones con el cliente,',
          5: 'Dirección IP,',
          6: 'Información del perfil de redes sociales, interacciones, contenido y otra información generada por el usuario.',
        },
        1: 'Las fuentes de datos son las empresas que forman parte de QRBrain. Sujeto a su consentimiento, recopilamos la información anterior de su uso de nuestro Sitio y Servicios mediante cookies y tecnologías similares (consulte nuestras Políticas de Cookies) para ser compartida y utilizada en todo QRBrain. Utilizamos los datos personales que recopilamos para una variedad de propósitos administrativos y comerciales, incluyendo:',
        item1: {
          0: 'Responder a consultas, preguntas y comentarios y proporcionar soporte al cliente y técnico, proporcionar acceso a ciertas funcionalidades de nuestros Servicios,',
          1: 'Brindar soporte centralizado para clientes con horarios de soporte extendidos,',
          2: 'Comunicación y actividades de ventas centralizadas y más eficientes con soporte extendido,',
          3: 'Mantener una plataforma central para la comunicación con los clientes,',
          4: 'Alinear y comunicar de manera más eficiente con nuestros clientes actuales y potenciales sobre nuestros Servicios,',
          5: 'Permitir a nuestros clientes comprender las interacciones con nuestros Servicios,',
          6: 'Analizar el comportamiento de uso del sitio web de los clientes y visitantes para comprender mejor las necesidades y deseos de los clientes y visitantes,',
          7: 'Ayudar a detectar, disuadir y prevenir actividades maliciosas, fraudulentas o ilegales para proteger nuestros Servicios y clientes, y el mal funcionamiento de los Sitios y Servicios,',
          8: 'Gestionar pagos y registros de clientes,',
          9: 'Usar la planificación financiera común para alinear e implementar estrategias y políticas financieras del grupo.',
        },
        2: 'Procesamos sus datos para brindar soporte al cliente, comunicaciones con clientes, optimizar y mejorar nuestro servicio y la experiencia del usuario, y procesar y gestionar pagos, o en la medida en que el propósito del contacto sea concluir un contrato o si ya tiene una Cuenta o utiliza de otro modo nuestros Servicios porque dicho procesamiento y contacto es necesario para concluir el contrato o proporcionar el Servicio. Los datos serán eliminados tan pronto como ya no sean necesarios para lograr el propósito para el cual fueron recopilados, en la medida en que no se permita o requiera un almacenamiento adicional por ley.',
        3: 'Cuando un usuario desactiva su cuenta (o lo hacemos nosotros en función de la inactividad a largo plazo), la información de la cuenta se anonimiza. Los datos de pago se anonimizan o eliminan después del período de retención para los registros contables y el período de limitación de los posibles pagos pendientes (deuda), el que ocurra más tarde según las leyes aplicables. Los datos de suscripción, datos de uso del producto y datos similares basados en las acciones de los usuarios se anonimizan o eliminan después de que hayan pasado tres (3) años desde la desactivación de la cuenta o el último contacto.',
      },
      marketing: {
        title: 'Marketing',
        0: 'QRBrain colabora para proporcionar servicios de soporte a nuestros clientes y para administrar y gestionar las relaciones con los clientes mediante el uso y compartición de los siguientes datos personales:',
        item: {
          0: 'Información de cuenta y suscripciones a los Servicios',
          1: 'Otros detalles de contacto no relacionados con una cuenta registrada',
          2: 'Datos personales incluidos en la información comercial (si es cliente corporativo)',
          3: 'Eventos de usuario, creación de cuenta, uso de productos y otros datos de uso (como registros, codificaciones, decodificaciones y vistas de página) de los Servicios',
          4: 'Información del perfil de redes sociales, interacciones, contenido y otra información generada por el usuario',
          5: 'Contenido de mensajería que los individuos eligen compartir (por ejemplo, mensajes en redes sociales, mensajes dentro de la aplicación, SMS)',
          6: 'Metadatos de redes sociales y mensajería (por ejemplo, número de seguidores en redes sociales, número de publicaciones, número de tweets)',
          7: 'Cualquier contenido, comunicaciones, mensajes, datos e información enviados o recibidos por el cliente a través de los Servicios',
          8: 'Otra información individual (por ejemplo, edad, género, empleador, profesión, ubicación geográfica, información educativa, estado financiero, intereses y preferencias) disponible en redes sociales o fuentes públicas',
        },
        1: 'QRBrain utiliza datos personales obtenidos a través de las siguientes plataformas de campañas publicitarias de terceros, recibidos como se describe en esta Política de Privacidad: Google Analytics & Ads, LinkedIn Ads & Marketing, Facebook Ads y Microsoft Advertising.',
        2: 'Utilizamos los datos personales que recopilamos con fines de marketing para:',
        item2: {
          0: 'Alinear las operaciones de marketing y las estrategias de marketing,',
          1: 'Ejecutar campañas de marketing comunes',
          2: 'Servir a los usuarios finales con publicidad basada en intereses, así como medir la efectividad de las campañas publicitarias',
          3: 'Interactuar con (potenciales) clientes y socios comerciales para promocionar los Servicios de QRBrain',
        },
        3: 'Recopilamos datos personales para los fines anteriores a través de tecnologías de seguimiento de socios de marketing en línea en relación con nuestros servicios de Código QR como se identifica en nuestro banner y política de cookies. La base legal para procesar datos personales según sea necesario para el marketing son nuestros intereses legítimos de promover ventas y aumentar la concienciación sobre QRBrain, y comunicarnos con nuestros grupos de interés. Donde el marketing requiere consentimiento bajo las leyes obligatorias aplicables, por ejemplo, si deseamos comercializar por correo electrónico nuestros Servicios a un nuevo cliente que sea una persona física en la UE, la base legal es el consentimiento del destinatario. Si nos ha dado su consentimiento para compartir sus datos con un proveedor externo, la base legal para el procesamiento de datos es su consentimiento. Sin embargo, un proveedor externo también puede formar parte de nuestros servicios (pre)contractuales, en cuyo caso la base legal para el procesamiento de datos es que el procesamiento es esencial para proporcionar los servicios. Los datos se eliminarán tan pronto como ya no sean necesarios para lograr el propósito para el que fueron recopilados, en la medida en que no se permita o requiera un almacenamiento adicional por ley.',
      },
      gdpr: {
        title: 'Derechos bajo el GDPR',
        0: 'Si es residente del EEE o Suiza, o está sujeto al GDPR de otro modo, y procesamos sus datos personales, tiene el derecho de solicitar los siguientes derechos:',
        item: {
          0: 'En todos los casos, el derecho a ser informado sobre el procesamiento por parte de QRBrain que se refiere a los datos personales con base en los cuales se le puede identificar, y acceso a una copia de dichos datos personales (Art. 15 GDPR).',
          1: 'Si los datos personales que se están procesando son incorrectos o inexactos, tiene derecho a solicitar la corrección de los datos (Art. 16 GDPR).',
          2: 'Sujeto a las condiciones establecidas en el GDPR, puede solicitar la eliminación o limitación del procesamiento y tiene derecho a oponerse al procesamiento en su totalidad (Art. 17, 18 y 21 GDPR).',
          3: 'Si el procesamiento se basa en su consentimiento o en un contrato y el procesamiento de datos se lleva a cabo mediante procedimientos automatizados, puede tener derecho a la portabilidad de los datos (Artículo 20 GDPR).',
          4: 'Si ha dado su consentimiento para el procesamiento de sus datos por parte del controlador de datos, puede revocar su consentimiento en cualquier momento. La legalidad del procesamiento de datos realizado sobre la base del consentimiento obtenido antes de la revocación no se verá afectada.',
        },
        1: 'Además, tiene derecho a apelar ante la autoridad supervisora competente (Art. 77 GDPR) si considera que el procesamiento de sus datos personales por parte de nosotros viola el GDPR u otras leyes de protección de datos aplicables.',
        subunder: 'Transferencia internacional de datos personales',
        2: 'Dependiendo de su ubicación, la información sobre usted puede transferirse a los Estados Unidos u otros países fuera de la UE o del Área Económica Europea (EEE) o puede procesarse allí. Estas transferencias de datos son necesarias para proporcionarle los Servicios y funcionalidades que ha solicitado, tal como se describe en esta política.',
        3: 'Para proteger sus datos personales, confiamos en una base legal adecuada para cada transferencia de datos. En particular, utilizamos garantías contractuales como las Cláusulas Contractuales Tipo aprobadas por la Comisión Europea. Cuando sea aplicable, también basamos las transferencias de datos en decisiones de adecuación emitidas por la Comisión Europea.',
        4: 'No dude en ponerse en contacto con nosotros para obtener más información sobre las transferencias internacionales de datos, incluida la posibilidad de obtener acceso a una copia de las garantías aplicables.',
      },
      california: {
        title: 'Derechos de Privacidad en California',
        0: 'La Ley de Privacidad del Consumidor de California de 2018 ("CCPA"), modificada por la Ley de Derechos de Privacidad de California de 2020, le otorga derechos específicos con respecto a su "información personal", tal como se define en la CCPA. Esta sección describe los derechos que tienen los consumidores de California y explica cómo ejercer esos derechos. A efectos de esta sección, la información personal no incluye: (i) información que se pone a disposición legalmente a partir de registros gubernamentales federales, estatales o locales; (ii) datos desidentificados o agregados; o (iii) información excluida del alcance de la CCPA. Para dejar claro, estos derechos solo se otorgan en la medida en que usted sea un consumidor de California y nosotros actuemos como "empresa" según la CCPA con respecto a su información personal. Los derechos en esta sección no están destinados a otorgarle derechos adicionales, sino solo sus derechos bajo la CCPA.',
        1: 'No utilizamos ni divulgamos información personal sensible, tal como se define en la CCPA. Las categorías de información personal descritas anteriormente se anonimizan o eliminan de nuestros sistemas a pedido, si los datos se detectan como irrelevantes en nuestro mantenimiento automático o manual del sistema, o después de 3 años tras el último contacto con la persona correspondiente, lo que ocurra primero.',
        sub1: 'Venta o Compartición de Información Personal',
        2: 'QRBrain no "vende" ni "comparte" su información personal a terceros, según se utilizan esos términos en la CCPA.',
        sub2: 'Derechos sobre su Información',
        3: 'a. Derecho a Saber',
        4: 'Como consumidor de California, tiene derecho a solicitar que le divulguemos cierta información sobre nuestra recopilación, uso, divulgación o venta/compartición de su información personal durante los últimos 12 meses. Una vez que recibamos y confirmemos su solicitud verificable de consumidor (consulte la sección Ejercicio de Sus Derechos, a continuación), y sujeto a ciertas limitaciones que describimos a continuación, le divulgaremos dicha información. Tiene derecho a solicitar cualquiera o todas las siguientes:',
        sub3: 'Las categorías de información personal que hemos recopilado sobre usted.',
        5: 'Las categorías de fuentes de las cuales se recopila la información personal. Nuestro propósito comercial o empresarial para la recopilación o venta de esa información personal. Las categorías de terceros con los que compartimos esa información personal. Las piezas específicas de información personal que recopilamos sobre usted (consulte los Derechos de Portabilidad de Datos a continuación).',
        6: 'b. Derecho a Eliminar',
        7: 'Tiene derecho a solicitar que eliminemos cualquier información personal suya que hayamos recopilado de usted y retenido, sujeto a ciertas excepciones. Una vez que recibamos y confirmemos su solicitud verificable de consumidor (consulte la sección Ejercicio de Sus Derechos, a continuación), eliminaremos (y ordenaremos a nuestros proveedores de servicios que eliminen) su información personal de nuestros registros, a menos que se aplique una excepción. Sin embargo, podemos retener información personal que haya sido desidentificada o agregada. Además, podemos denegar su solicitud de eliminación si conservar la información es necesario para nosotros o nuestros proveedores de servicios para realizar ciertas acciones establecidas bajo la CCPA, como detectar incidentes de seguridad y proteger contra actividades fraudulentas o ilegales.',
        8: 'c. Derecho a la Portabilidad de Datos',
        9: 'Tiene derecho a solicitar una copia de la información personal que hemos recopilado y mantenido sobre usted en los últimos 12 meses. La CCPA le permite solicitar su información de nosotros hasta dos veces durante un período de 12 meses. Proporcionaremos nuestra respuesta en un formato fácilmente utilizable (y generalmente electrónico).',
        10: 'd. Derecho a Corregir',
        11: 'Tiene derecho a solicitar la corrección de cualquier información personal que mantengamos sobre usted.',
        12: 'e. Derecho a No Discriminación',
        13: 'No lo discriminaremos por ejercer cualquiera de sus derechos bajo la CCPA, incluidos, entre otros:',
        14: 'Negarle bienes o servicios. Cobrarle diferentes precios o tarifas por bienes o servicios, incluidos otorgar descuentos u otros beneficios, o imponer sanciones. Proporcionarle un nivel o calidad diferente de bienes o servicios. Sugerirle que puede recibir un precio o tarifa diferente por bienes o servicios o un nivel o calidad diferente de bienes o servicios.',
        15: 'f. Ejercicio de sus Derechos',
        16: 'Para ejercer los derechos descritos anteriormente, comuníquese con nosotros utilizando los siguientes métodos:',
        17: 'Envíenos un correo electrónico a support@qrbrain.io',
        18: 'Después de enviar una solicitud, tomaremos medidas para verificar su identidad para poder responder de manera adecuada y confirmar que no se trata de una solicitud fraudulenta. Para verificar su identidad, le pediremos, como mínimo, que proporcione su nombre, dirección de correo electrónico y relación con nosotros, para que podamos intentar comparar esta información con la información existente en nuestros sistemas. Al proporcionarnos esta información, usted declara y afirma que toda la información proporcionada es verdadera y precisa. Dependiendo de la solicitud, si no podemos verificar que el consumidor que envió la solicitud es la misma persona sobre la que hemos recopilado información personal, podemos comunicarnos con usted para obtener más información, o es posible que no podamos cumplir con su solicitud.',
        19: 'Solo usted, o un agente legalmente autorizado para actuar en su nombre, puede hacer una solicitud verificable relacionada con su información personal. Si está realizando una solicitud como agente autorizado de un consumidor de California, le pediremos que envíe una prueba confiable de que ha sido autorizado por escrito por el consumidor para actuar en su nombre.',
        20: 'Haremos todo lo posible para responder a su solicitud dentro de los 45 días desde el momento en que se puso en contacto con nosotros. Si tiene una solicitud compleja, la CCPA nos permite hasta 90 días para responder. Aún así, nos pondremos en contacto con usted dentro de los 45 días desde el momento en que se puso en contacto con nosotros para informarle que necesitamos más tiempo para responder.',
        21: 'California “Shine the Light” Además de los derechos anteriores, bajo la Sección 1798.83 del Código Civil de California (“Shine the Light”), los residentes de California pueden tener derecho a solicitar por escrito a las empresas con las que tienen una relación comercial establecida: (a) una lista de las categorías de información personal, según se define en Shine the Light, como nombre, dirección de correo electrónico y dirección postal, y el tipo de servicios proporcionados al cliente que una empresa ha divulgado a terceros (incluidos afiliados que son entidades legales separadas) durante el año calendario inmediatamente anterior para fines de marketing directo de terceros; y (b) los nombres y direcciones de todos esos terceros. Para solicitar la información anterior, comuníquese con nosotros por correo electrónico a support@qrbrain.io. Si no desea que su información personal se comparta con ningún tercero que pueda utilizar dicha información con fines de marketing directo, entonces puede optar por no recibir dichas divulgaciones enviándonos un correo electrónico a support@qrbrain.io.',
        22: 'Ponerse en contacto con nosotros',
        23: 'Si tiene preguntas o inquietudes sobre esta política de privacidad, sus derechos de privacidad en California o nuestras prácticas de información, envíenos un correo electrónico a support@qrbrain.io.',
      },
      virgina: {
        title: 'Derechos de Privacidad en Virginia/Colorado/Connecticut y ciertos otros estados de EE. UU.',
        0: 'La Ley de Protección de Datos del Consumidor de Virginia, la Ley de Privacidad de Colorado y la Ley de Privacidad de Datos de Connecticut, y leyes similares en otros estados de EE. UU. (“Leyes de Privacidad del Estado”) otorgan a sus consumidores derechos específicos con respecto a sus datos personales. En la medida en que sea residente de uno de estos estados, esta sección describe sus derechos bajo las Leyes de Privacidad del Estado y explica cómo puede ejercer esos derechos.',
        1: 'Las categorías de datos personales que procesamos, nuestros propósitos para procesar sus datos personales, las categorías de datos personales que compartimos con terceros y las categorías de terceros con los que los compartimos se establecen en los términos de la Política de Privacidad anterior.',
        2: 'Además de los derechos establecidos en nuestra Política de Privacidad, las Leyes de Privacidad del Estado le otorgan los siguientes derechos:',
        item: {
          0: {
            title: 'Derecho a saber.',
            desc: 'Tiene derecho a saber si procesamos sus datos personales y a acceder a dichos datos personales.',
          },
          1: {
            title: 'Derecho a la portabilidad de datos.',
            desc: 'Tiene derecho a obtener una copia de sus datos personales que nos haya proporcionado anteriormente en un formato portátil y, en la medida en que sea técnicamente factible, de fácil uso que le permita transmitir los datos a otra empresa sin obstáculos, cuando el procesamiento se realice mediante medios automatizados. Puede solicitar dichos datos personales hasta dos veces al año, sujeto a ciertas excepciones.',
          },
          2: {
            title: 'Derecho a eliminar.',
            desc: 'Tiene derecho a eliminar los datos personales que nos haya proporcionado o que hayamos obtenido sobre usted. Tenga en cuenta que podemos denegar dicha solicitud si la eliminación solicitada entra en una excepción establecida en las Leyes de Privacidad del Estado. Además, si solicita la eliminación de sus datos personales y hemos obtenido dicha información de una fuente externa, podemos retener dichos datos manteniendo un registro de la solicitud de eliminación y los datos mínimos necesarios para garantizar que sus datos personales permanezcan eliminados de nuestros registros y que dichos datos retenidos no se utilicen para ningún otro propósito, o podemos excluirlo del procesamiento de dichos datos personales para cualquier propósito, excepto aquellos permitidos por las Leyes de Privacidad del Estado.',
          },
          3: {
            title: 'Derecho a excluirse.',
            desc: 'Tiene derecho a excluirse del procesamiento de los datos personales para los siguientes fines: (i) publicidad dirigida; (ii) la venta de datos personales; o (iii) elaboración de perfiles en apoyo de decisiones que produzcan efectos legales o de importancia similar que le afecten. A partir de la fecha más reciente de la Política de Privacidad:',
            subItems: {
              0: 'No procesamos datos personales con fines de publicidad dirigida;',
              1: 'No vendemos sus datos personales; y',
              2: 'No nos dedicamos a decisiones de elaboración de perfiles basadas en sus datos personales que produzcan efectos legales o de importancia similar que le afecten.',
            },
          },
          4: {
            title: 'Derecho a corregir.',
            desc: 'Tiene derecho a corregir inexactitudes en sus datos personales, teniendo en cuenta la naturaleza de los datos personales y los fines para los que los procesamos.',
          },
          5: {
            title: 'Derecho a no discriminación.',
            desc: 'Tiene derecho a no recibir un trato discriminatorio por parte de nosotros por el ejercicio de sus derechos de privacidad. A menos que lo permitan las Leyes de Privacidad del Estado, no haremos lo siguiente:',
          },
        },
        3: 'Negarle bienes o servicios; Cobrarle diferentes precios o tarifas por bienes o servicios, incluidos otorgar descuentos u otros beneficios, o imponer sanciones; Proporcionarle un nivel o calidad diferente de bienes o servicios; o Sugerirle que puede recibir un precio o tarifa diferente por bienes o servicios o un nivel o calidad diferente de bienes o servicios. Cómo ejercer sus derechos; Verificación de su identidad',
        4: 'Para ejercer cualquiera de sus derechos de privacidad, o si tiene alguna pregunta sobre sus derechos de privacidad, puede comunicarse con nosotros por:',
        5: 'Enviándonos un correo electrónico a support@qrbrain.io',
        6: 'Después de enviar una solicitud, tomaremos medidas para verificar su identidad para poder responder de manera adecuada y/o confirmar que su solicitud no es fraudulenta. Podemos comunicarnos con usted para obtener información adicional según sea razonablemente necesario para autenticar su solicitud, pero si finalmente no podemos autenticar su solicitud utilizando esfuerzos comerciales razonables, es posible que no podamos cumplir con ella.',
        7: 'Solo usted o su agente autorizado pueden hacer una solicitud verificable relacionada con sus datos personales. Si está realizando una solicitud como padre o tutor legal de un niño conocido con respecto al procesamiento de los datos personales de ese niño, podemos pedirle que presente una prueba confiable de su identidad.',
        8: 'Tiempo de respuesta; Su derecho a apelar',
        9: 'Haremos todo lo posible para responder a su solicitud dentro de los 45 días desde el momento en que se puso en contacto con nosotros. Si tiene una solicitud compleja, las leyes de privacidad del estado nos permiten hasta 90 días para responder. Nos pondremos en contacto con usted dentro de los 45 días desde el momento en que se puso en contacto con nosotros para informarle de la necesidad de más tiempo y la razón de dicha extensión. Podemos cobrarle una tarifa razonable para cubrir los costos administrativos si sus solicitudes son manifiestamente infundadas, excesivas o repetitivas.',
        10: 'Si nos negamos a actuar sobre una solicitud que ha enviado, le informaremos nuestras razones para hacerlo y le proporcionaremos instrucciones sobre cómo apelar la decisión. Tendrá derecho a apelar dentro de un período de tiempo razonable después de haber recibido nuestra decisión. Dentro de los 60 días (45 días para los residentes de Colorado) desde la recepción de su apelación, le informaremos por escrito de cualquier acción tomada o no tomada en respuesta a la apelación, incluida una explicación por escrito de las razones de las decisiones. Si denegamos su apelación, le proporcionaremos un método para ponerse en contacto con la oficina del fiscal general de su estado para presentar una queja.',
        sub: 'Derechos de Privacidad en Nevada',
        11: 'Si es residente de Nevada, tiene derecho a excluirse de la venta de ciertos datos personales que hemos recopilado (o podemos recopilar) de usted a corredores de datos u otros terceros. Puede ejercer este derecho enviándonos un correo electrónico a support@qrbrain.io con el asunto "Solicitud de No Venta de Nevada".',
      },
      children: {
        title: 'Privacidad Infantil',
        0: 'No recopilamos conscientemente datos personales de niños. Si nos enteramos de que hemos recopilado datos personales de un niño menor de 13 años (o mayor según lo exija la ley aplicable), tomaremos medidas para eliminar dicha información de nuestros sistemas lo antes posible. Si cree que podemos tener datos personales de o sobre un niño menor de 13 años, comuníquese con nosotros en support@qrbrain.io.',
      },
      dataprivacy: {
        title: 'Marco de Privacidad de Datos (Extensión UE-EE. UU., Extensión del Reino Unido y Suiza-EE. UU.)',
        0: 'QRBrain cumple con el Marco de Privacidad de Datos UE-EE. UU. (EU-U.S. DPF), la Extensión del Reino Unido al EU-U.S. DPF, y el Marco de Privacidad de Datos Suiza-EE. UU. (Swiss-U.S. DPF), tal como lo establece el Departamento de Comercio de EE. UU. QRBrain ha certificado ante el Departamento de Comercio de EE. UU. que cumple con los Principios del Marco de Privacidad de Datos UE-EE. UU. (Principios DPF UE-EE. UU.) con respecto al procesamiento de datos personales recibidos de la Unión Europea en virtud del EU-U.S. DPF y del Reino Unido (y Gibraltar) en virtud de la Extensión del Reino Unido al EU-U.S. DPF. QRBrain ha certificado ante el Departamento de Comercio de EE. UU. que cumple con los Principios del Marco de Privacidad de Datos Suiza-EE. UU. (Principios DPF Suiza-EE. UU.) con respecto al procesamiento de datos personales recibidos de Suiza en virtud del Swiss-U.S. DPF. Si existe algún conflicto entre los términos de esta política de privacidad y los Principios del DPF UE-EE. UU. y/o los Principios del DPF Suiza-EE. UU., prevalecerán los Principios. Para obtener más información sobre el programa de Marco de Privacidad de Datos (DPF), y para ver nuestra certificación, visite https://www.dataprivacyframework.gov/.',
        1: 'En cumplimiento con el DPF UE-EE. UU. y el DPF Suiza-EE. UU., QRBrain se compromete a remitir las quejas no resueltas relacionadas con nuestro manejo de datos personales recibidos en virtud del DPF UE-EE. UU. y el DPF Suiza-EE. UU. a JAMS Data Privacy Framework Dispute Resolution, un proveedor de resolución alternativa de disputas con sede en los Estados Unidos. Si no recibe un reconocimiento oportuno de su queja relacionada con los Principios del DPF por parte de nosotros, o si no hemos abordado su queja relacionada con los Principios del DPF de manera satisfactoria, visite https://www.jamsadr.com/eu-us-data-privacy-framework para obtener más información o presentar una queja. Los servicios de JAMS Data Privacy Framework Dispute Resolution se proporcionan sin costo para usted.',
      },
      change: {
        title: 'Cambios en nuestra Política de Privacidad',
        0: 'Nos reservamos el derecho de realizar cambios a esta Política de Privacidad en cualquier momento. Si realizamos cambios materiales en la forma en que recopilamos o utilizamos la información, proporcionaremos un aviso publicando un anuncio en los Servicios o enviándole un correo electrónico, e indicaremos cuándo esos cambios entrarán en vigor. Usted acepta cualquier cambio en la Política de Privacidad cuando utilice los Servicios después de que dichos cambios entren en vigor.',
      },
    },
    toc: {
      general: {
        title: 'Términos Generales',
        0: 'Al acceder y realizar un pedido con QRBrain.io, confirmas que estás de acuerdo y sujeto a los términos de servicio contenidos en los Términos y Condiciones que se describen a continuación. Estos términos se aplican a todo el sitio web y a cualquier correo electrónico u otro tipo de comunicación entre tú y QRBrain.io.',
        1: 'Bajo ninguna circunstancia el equipo de QRBrain.io será responsable de ningún daño directo, indirecto, especial, incidental o consecuente, incluidos, entre otros, la pérdida de datos o ganancias, que surjan del uso o la imposibilidad de usar los materiales en este sitio, incluso si el equipo de QRBrain.io o un representante autorizado ha sido advertido de la posibilidad de tales daños. Si el uso de los materiales de este sitio da lugar a la necesidad de servicio, reparación o corrección de equipos o datos, asumes cualquier costo derivado de ello.',
        2: 'QRBrain.io no será responsable de ningún resultado que pueda ocurrir durante el uso de nuestros recursos. Nos reservamos el derecho de cambiar precios y revisar la política de uso de los recursos en cualquier momento.',
      },
      license: {
        title: 'Licencia',
        0: 'QRBrain.io te otorga una licencia revocable, no exclusiva, intransferible y limitada para descargar, instalar y usar el sitio web estrictamente de acuerdo con los términos de este Acuerdo.',
        1: 'Estos Términos y Condiciones son un contrato entre tú y QRBrain.io (referido en estos Términos y Condiciones como "QRBrain.io", "nosotros" o "nuestro"), el proveedor del sitio web de QRBrain.io y los servicios accesibles desde el sitio web de QRBrain.io (que se denominan colectivamente en estos Términos y Condiciones como el "Servicio QRBrain.io").',
        2: 'Estás de acuerdo en estar sujeto a estos Términos y Condiciones. Si no estás de acuerdo con estos Términos y Condiciones, por favor no uses el Servicio QRBrain.io. En estos Términos y Condiciones, "tú" se refiere tanto a ti como individuo como a la entidad que representas. Si violas alguno de estos Términos y Condiciones, nos reservamos el derecho de cancelar tu cuenta o bloquear el acceso a tu cuenta sin previo aviso.',
      },
      definitions: {
        title: 'Definiciones y términos clave',
        0: 'Para ayudar a explicar las cosas de la manera más clara posible en estos Términos y Condiciones, cada vez que se haga referencia a cualquiera de estos términos, se definen estrictamente como:',
        item: {
          0: 'Cookie: pequeña cantidad de datos generados por un sitio web y guardados por tu navegador web. Se utiliza para identificar tu navegador, proporcionar análisis, recordar información sobre ti, como tus preferencias de idioma o información de inicio de sesión.',
          1: 'Compañía: cuando esta política menciona “Compañía”, “nosotros” o “nuestro”, se refiere a QRBrain.io, que es responsable de tu información bajo estos Términos y Condiciones.',
          2: 'País: donde se encuentran QRBrain.io o los propietarios/fundadores de QRBrain.io, en este caso es AR',
          3: 'Dispositivo: cualquier dispositivo conectado a internet, como un teléfono, tableta, computadora o cualquier otro dispositivo que pueda ser usado para visitar QRBrain.io y usar los servicios.',
          4: 'Servicio: se refiere al servicio proporcionado por QRBrain.io, tal como se describe en los términos relativos (si están disponibles) y en esta plataforma.',
          5: 'Servicio de terceros: se refiere a anunciantes, patrocinadores de concursos, socios promocionales y de marketing, y otros que proporcionan nuestro contenido o cuyos productos o servicios creemos que pueden interesarte.',
          6: 'Sitio web: el sitio de QRBrain.io, que se puede acceder a través de esta URL: https://qrbrain.io',
          7: 'Tú: una persona o entidad que está registrada en QRBrain.io para usar los Servicios.',
        },
      },
      restrictions: {
        title: 'Restricciones',
        0: 'Aceptas no, y no permitirás que otros:',
        item: {
          0: 'Licencien, vendan, alquilen, arrienden, asignen, distribuyan, transmitan, alojen, subcontraten, divulguen o exploten comercialmente el sitio web o pongan la plataforma a disposición de terceros.',
          1: 'Modifiquen, creen trabajos derivados de, desensamblen, descifren, compilen de manera inversa o realicen ingeniería inversa de cualquier parte del sitio web.',
          2: 'Remuevan, alteren o oculten cualquier aviso de propiedad (incluyendo cualquier aviso de derechos de autor o marca registrada) de QRBrain.io o sus afiliados, socios, proveedores o los licenciadores del sitio web.',
        },
      },
      return: {
        title: 'Política de Devolución y Reembolso',
        0: 'Gracias por comprar en QRBrain.io. Apreciamos el hecho de que te guste comprar lo que construimos. También queremos asegurarnos de que tengas una experiencia gratificante mientras exploras, evalúas y compras nuestros productos.',
        1: 'Como en cualquier experiencia de compra, existen términos y condiciones que se aplican a las transacciones en QRBrain.io. Seremos tan breves como lo permitan nuestros abogados. Lo principal a recordar es que al realizar un pedido o compra en QRBrain.io, aceptas los términos junto con la Política de Privacidad de QRBrain.io.',
        2: 'Si, por alguna razón, no estás completamente satisfecho con algún producto o servicio que proporcionamos, no dudes en contactarnos y discutiremos cualquier problema que estés teniendo con nuestro producto.',
      },
      suggest: {
        title: 'Tus Sugerencias',
        0: 'Cualquier comentario, idea, mejora o sugerencia (colectivamente, "Sugerencias") proporcionada por ti a QRBrain.io con respecto al sitio web seguirá siendo propiedad exclusiva de QRBrain.io.',
        1: 'QRBrain.io tendrá la libertad de usar, copiar, modificar, publicar o redistribuir las Sugerencias para cualquier propósito y de cualquier manera sin ningún crédito o compensación para ti.',
      },
      consent: {
        title: 'Tu Consentimiento',
        0: 'Hemos actualizado nuestros Términos y Condiciones para brindarte total transparencia sobre lo que se establece cuando visitas nuestro sitio y cómo se utiliza. Al utilizar nuestro sitio web, registrar una cuenta o realizar una compra, consientes nuestros Términos y Condiciones.',
      },
      links: {
        title: 'Enlaces a Otros Sitios Web',
        0: 'Estos Términos y Condiciones se aplican solo a los Servicios. Los Servicios pueden contener enlaces a otros sitios web que no son operados o controlados por QRBrain.io. No somos responsables del contenido, la exactitud o las opiniones expresadas en dichos sitios web, y tales sitios no son investigados, monitoreados o verificados por nosotros en cuanto a su exactitud o integridad. Recuerda que cuando usas un enlace para ir desde los Servicios a otro sitio web, nuestros Términos y Condiciones ya no están en vigor. Tu navegación e interacción en cualquier otro sitio web, incluidos aquellos que tienen un enlace en nuestra plataforma, están sujetos a las propias reglas y políticas de ese sitio web. Tales terceros pueden usar sus propias cookies u otros métodos para recopilar información sobre ti.',
      },
      cookies: {
        title: 'Cookies',
        0: 'QRBrain.io utiliza "Cookies" para identificar las áreas de nuestro sitio web que has visitado. Una Cookie es una pequeña pieza de datos almacenada en tu computadora o dispositivo móvil por tu navegador web. Utilizamos Cookies para mejorar el rendimiento y la funcionalidad de nuestro sitio web, pero no son esenciales para su uso. Sin embargo, sin estas cookies, ciertas funcionalidades como los videos pueden no estar disponibles o tendrías que ingresar tus datos de inicio de sesión cada vez que visites el sitio web, ya que no podríamos recordar que habías iniciado sesión anteriormente. La mayoría de los navegadores web pueden configurarse para deshabilitar el uso de Cookies. Sin embargo, si deshabilitas las Cookies, es posible que no puedas acceder correctamente o en absoluto a la funcionalidad de nuestro sitio web. Nunca colocamos Información de Identificación Personal en Cookies.',
      },
      change: {
        title: 'Cambios en Nuestros Términos y Condiciones',
        0: 'Reconoces y aceptas que QRBrain.io puede detener (permanente o temporalmente) la prestación del Servicio (o cualquier característica dentro del Servicio) a ti o a los usuarios en general a discreción exclusiva de QRBrain.io, sin previo aviso. Puedes dejar de usar el Servicio en cualquier momento. No necesitas informar específicamente a QRBrain.io cuando dejes de usar el Servicio. Reconoces y aceptas que si QRBrain.io deshabilita el acceso a tu cuenta, es posible que se te impida acceder al Servicio, a los detalles de tu cuenta o a cualquier archivo u otros materiales contenidos en tu cuenta.',
        1: 'Si decidimos cambiar nuestros Términos y Condiciones, publicaremos esos cambios en esta página y/o actualizaremos la fecha de modificación de los Términos y Condiciones a continuación.',
      },
      modify: {
        title: 'Modificaciones a Nuestro Sitio Web',
        0: 'QRBrain.io se reserva el derecho de modificar, suspender o descontinuar, temporal o permanentemente, el sitio web o cualquier servicio al que esté conectado, con o sin previo aviso y sin responsabilidad hacia ti.',
      },
      updates: {
        title: 'Actualizaciones a Nuestro Sitio Web',
        0: 'QRBrain.io puede, de vez en cuando, proporcionar mejoras o mejoras a las características/funcionalidad del sitio web, que pueden incluir parches, correcciones de errores, actualizaciones, mejoras y otras modificaciones ("Actualizaciones").',
        1: 'Las Actualizaciones pueden modificar o eliminar ciertas características y/o funcionalidades del sitio web. Aceptas que QRBrain.io no tiene la obligación de (i) proporcionar ninguna Actualización o (ii) continuar proporcionando o habilitando cualquier característica o funcionalidad particular del sitio web.',
        2: 'Además, aceptas que todas las Actualizaciones se considerarán como parte integral del sitio web y estarán sujetas a los términos y condiciones de este Acuerdo.',
      },
      ownership: {
        title: 'Propiedad del Producto Final',
        0: 'Los datos y la propiedad intelectual de los códigos que generas son de tu propiedad.',
      },
      service: {
        title: 'Servicios de Terceros',
        0: 'Podemos mostrar, incluir o poner a disposición contenido de terceros (incluidos datos, información, aplicaciones y otros productos servicios) o proporcionar enlaces a sitios web o servicios de terceros ("Servicios de Terceros").',
        1: 'Reconoces y aceptas que QRBrain.io no será responsable de ningún Servicio de Terceros, incluida su exactitud, integridad, oportunidad, validez, cumplimiento de derechos de autor, legalidad, decencia, calidad o cualquier otro aspecto del mismo. QRBrain.io no asume ni tendrá ninguna responsabilidad u obligación ante ti o cualquier otra persona o entidad por ningún Servicio de Terceros.',
        2: 'Los Servicios de Terceros y los enlaces a ellos se proporcionan únicamente para tu conveniencia y los accedes y utilizas bajo tu propio riesgo y sujeto a los términos y condiciones de dichos terceros.',
      },
      termination: {
        title: 'Duración y Terminación',
        0: 'Este Acuerdo permanecerá en vigor hasta que lo rescindas tú o QRBrain.io.',
        1: 'QRBrain.io puede, a su entera discreción, en cualquier momento y por cualquier motivo o sin motivo alguno, suspender o rescindir este Acuerdo con o sin previo aviso.',
        2: 'Este Acuerdo terminará inmediatamente, sin previo aviso de QRBrain.io, en caso de que no cumplas con alguna disposición de este Acuerdo. También puedes rescindir este Acuerdo eliminando el sitio web y todas las copias del mismo de tu computadora.',
        3: 'Al finalizar este Acuerdo, deberás cesar todo uso del sitio web y eliminar todas las copias del sitio web de tu computadora.',
        4: 'La terminación de este Acuerdo no limitará los derechos o recursos de QRBrain.io en derecho o en equidad en caso de incumplimiento por tu parte (durante el período de vigencia de este Acuerdo) de cualquiera de tus obligaciones bajo este Acuerdo.',
      },
      copyright: {
        title: 'Aviso de Infracción de Derechos de Autor',
        0: 'Si eres propietario de derechos de autor o agente de dicho propietario y crees que algún material en nuestro sitio web constituye una infracción de tus derechos de autor, por favor contáctanos proporcionando la siguiente información: (a) una firma física o electrónica del propietario de los derechos de autor o de una persona autorizada para actuar en su nombre; (b) identificación del material que se afirma que está infringiendo; (c) tu información de contacto, incluida tu dirección, número de teléfono y correo electrónico; (d) una declaración tuya de que tienes una creencia de buena fe de que el uso del material no está autorizado por los propietarios de los derechos de autor; y (e) una declaración de que la información en la notificación es precisa y que, bajo pena de perjurio, estás autorizado a actuar en nombre del propietario.',
      },
      indemnification: {
        title: 'Indemnización',
        0: 'Aceptas indemnizar y mantener indemne a QRBrain.io y sus matrices, subsidiarias, afiliados, funcionarios, empleados, agentes, socios y licenciatarios (si los hay) de cualquier reclamación o demanda, incluidos los honorarios razonables de abogados, debido a o que surjan de tu: (a) uso del sitio web; (b) violación de este Acuerdo o de cualquier ley o regulación; o (c) violación de cualquier derecho de un tercero.',
      },
      warranties: {
        title: 'Sin Garantías',
        0: 'El sitio web te es proporcionado "TAL COMO ESTÁ" y "SEGÚN DISPONIBILIDAD" y con todos los defectos y fallas sin garantía de ningún tipo. En la máxima medida permitida por la ley aplicable, QRBrain.io, en su propio nombre y en nombre de sus afiliados y de sus respectivos licenciantes y proveedores de servicios, renuncia expresamente a todas las garantías, ya sean expresas, implícitas, legales o de otro tipo, con respecto al sitio web, incluidas todas las garantías implícitas de comerciabilidad, idoneidad para un propósito particular, titularidad y no infracción, y garantías que puedan surgir del curso de la negociación, el curso del desempeño, el uso o la práctica comercial. Sin limitación de lo anterior, QRBrain.io no ofrece garantía ni compromiso, ni hace ninguna representación de ningún tipo de que el sitio web cumplirá con tus requisitos, logrará los resultados previstos, será compatible o funcionará con cualquier otro software, sistemas o servicios, operará sin interrupciones, cumplirá con cualquier estándar de rendimiento o fiabilidad, estará libre de errores o que cualquier error o defecto puede o será corregido.',
        1: 'Sin limitar lo anterior, ni QRBrain.io ni ninguno de los proveedores de QRBrain.io hacen ninguna representación o garantía de ningún tipo, expresa o implícita: (i) sobre el funcionamiento o la disponibilidad del sitio web, o la información, el contenido y los materiales o productos incluidos en el mismo; (ii) que el sitio web será ininterrumpido o libre de errores; (iii) sobre la exactitud, fiabilidad o actualidad de cualquier información o contenido proporcionado a través del sitio web; o (iv) que el sitio web, sus servidores, el contenido o los correos electrónicos enviados desde o en nombre de QRBrain.io están libres de virus, scripts, caballos de Troya, gusanos, malware, bombas de tiempo u otros componentes dañinos.',
        2: 'Algunas jurisdicciones no permiten la exclusión de garantías implícitas o las limitaciones sobre los derechos legales aplicables de un consumidor, por lo que algunas o todas las exclusiones y limitaciones anteriores pueden no aplicarse a ti.',
      },
      limit: {
        title: 'Limitación de Responsabilidad',
        0: 'No obstante cualquier daño que puedas sufrir, la responsabilidad total de QRBrain.io y de cualquiera de sus proveedores bajo cualquier disposición de este Acuerdo y tu remedio exclusivo para todos los anteriores se limitará al monto realmente pagado por ti por el sitio web.',
        1: 'En la máxima medida permitida por la ley aplicable, en ningún caso QRBrain.io o sus proveedores serán responsables de ningún daño especial, incidental, indirecto o consecuente de ningún tipo (incluidos, entre otros, daños por pérdida de beneficios, pérdida de datos o de otra información, interrupción del negocio, lesiones personales, pérdida de privacidad que surjan de o estén relacionados de alguna manera con el uso de o la imposibilidad de usar el sitio web, software de terceros y/o hardware de terceros utilizado con el sitio web, o de otro modo en relación con cualquier disposición de este Acuerdo), incluso si QRBrain.io o cualquier proveedor ha sido advertido de la posibilidad de tales daños e incluso si el recurso no cumple con su propósito esencial.',
        2: 'Algunos estados/jurisdicciones no permiten la exclusión o limitación de daños incidentales o consecuentes, por lo que la limitación o exclusión anterior puede no aplicarse a ti.',
      },
      sever: {
        title: 'Divisibilidad',
        0: 'Si alguna disposición de este Acuerdo es considerada inejecutable o inválida, dicha disposición será modificada e interpretada para lograr los objetivos de dicha disposición en la mayor medida posible bajo la ley aplicable y las disposiciones restantes continuarán en pleno vigor y efecto.',
        1: 'Este Acuerdo, junto con la Política de Privacidad y cualquier otro aviso legal publicado por QRBrain.io en los Servicios, constituirá el acuerdo completo entre tú y QRBrain.io en cuanto a los Servicios. Si alguna disposición de este Acuerdo es considerada inválida por un tribunal de jurisdicción competente, la invalidez de dicha disposición no afectará la validez de las disposiciones restantes de este Acuerdo, que permanecerán en pleno vigor y efecto. Ninguna renuncia a ningún término de este Acuerdo se considerará una renuncia adicional o continua de dicho término o de cualquier otro término, y la falta de QRBrain.io para hacer valer cualquier derecho o disposición bajo este Acuerdo no constituirá una renuncia a tal derecho o disposición. TÚ Y QRBrain.io ACUERDAN QUE CUALQUIER CAUSA DE ACCIÓN QUE SURJA O ESTÉ RELACIONADA CON LOS SERVICIOS DEBE COMENZAR DENTRO DE UN (1) AÑO DESPUÉS DE QUE SURJA LA CAUSA DE ACCIÓN. DE LO CONTRARIO, DICHA CAUSA DE ACCIÓN ESTÁ PERMANENTEMENTE PROHIBIDA.',
      },
      waiver: {
        title: 'Renuncia',
        0: 'Excepto según lo dispuesto en este documento, la falta de ejercicio de un derecho o de exigir el cumplimiento de una obligación bajo este Acuerdo no afectará la capacidad de una parte para ejercer dicho derecho o exigir dicho cumplimiento en cualquier momento posterior, ni la renuncia de un incumplimiento constituirá una renuncia a cualquier incumplimiento posterior.',
        1: 'Ninguna falta de ejercicio, ni ningún retraso en el ejercicio, por parte de cualquiera de las partes, de cualquier derecho o poder bajo este Acuerdo operará como una renuncia a dicho derecho o poder. Tampoco ningún ejercicio único o parcial de cualquier derecho o poder bajo este Acuerdo excluirá el ejercicio posterior de ese o cualquier otro derecho concedido en este documento. En caso de conflicto entre este Acuerdo y cualquier compra aplicable u otros términos, prevalecerán los términos de este Acuerdo.',
      },
      amendments: {
        title: 'Modificaciones a este Acuerdo',
        0: 'QRBrain.io se reserva el derecho, a su exclusivo criterio, de modificar o reemplazar este Acuerdo en cualquier momento. Si una revisión es material, proporcionaremos al menos 30 días de aviso antes de que entren en vigencia los nuevos términos. Lo que constituye un cambio material será determinado a nuestro exclusivo criterio.',
        1: 'Al continuar accediendo o utilizando nuestro sitio web después de que cualquier revisión entre en vigencia, aceptas estar sujeto a los términos revisados. Si no estás de acuerdo con los nuevos términos, ya no estás autorizado a usar QRBrain.io.',
      },
      entire: {
        title: 'Acuerdo Completo',
        0: 'El Acuerdo constituye el acuerdo completo entre tú y QRBrain.io con respecto al uso del sitio web y reemplaza todos los acuerdos anteriores y contemporáneos, tanto escritos como orales, entre tú y QRBrain.io.',
        1: 'Puedes estar sujeto a términos y condiciones adicionales que se aplican cuando utilizas o compras otros servicios de QRBrain.io, que QRBrain.io te proporcionará en el momento de dicho uso o compra.',
      },
      updatesTerm: {
        title: 'Actualizaciones a Nuestros Términos',
        0: 'Podemos cambiar nuestro Servicio y políticas, y es posible que necesitemos realizar cambios en estos Términos para que reflejen con precisión nuestro Servicio y políticas. A menos que lo exija la ley, te notificaremos (por ejemplo, a través de nuestro Servicio) antes de realizar cambios en estos Términos y te daremos la oportunidad de revisarlos antes de que entren en vigencia. Luego, si continúas usando el Servicio, estarás sujeto a los Términos actualizados. Si no deseas aceptar estos o cualquier Término actualizado, puedes eliminar tu cuenta.',
      },
      intellectual: {
        title: 'Propiedad Intelectual',
        0: 'El sitio web y todo su contenido, características y funcionalidad (incluyendo pero no limitado a toda la información, software, textos, pantallas, imágenes, video y audio, y el diseño, selección y disposición de los mismos), son propiedad de QRBrain.io, sus licenciantes u otros proveedores de dicho material y están protegidos por las leyes de derechos de autor, marcas registradas, patentes, secretos comerciales y otras leyes de propiedad intelectual o derechos de propiedad de AR e internacionales. El material no puede ser copiado, modificado, reproducido, descargado o distribuido de ninguna manera, en su totalidad o en parte, sin el permiso previo por escrito de QRBrain.io, a menos que y excepto según lo expresamente provisto en estos Términos y Condiciones. Cualquier uso no autorizado del material está prohibido.',
      },
      arbitrate: {
        title: 'Acuerdo para Arbitrar',
        0: 'Esta sección se aplica a cualquier disputa EXCEPTO NO INCLUYE UNA DISPUTA RELACIONADA CON RECLAMOS POR MEDIDAS CAUTELARES O ALIVIO EQUITATIVO CON RESPECTO A LA EJECUCIÓN O VALIDEZ DE TUS DERECHOS DE PROPIEDAD INTELECTUAL O LOS DE QRBrain.io. El término “disputa” significa cualquier disputa, acción u otra controversia entre tú y QRBrain.io en relación con los Servicios o este acuerdo, ya sea por contrato, garantía, agravio, estatuto, regulación, ordenanza o cualquier otra base legal o equitativa. “Disputa” se interpretará en el sentido más amplio posible permitido por la ley.',
      },
      dispute: {
        title: 'Aviso de Disputa',
        0: 'En caso de disputa, tú o QRBrain.io deben proporcionar a la otra parte un Aviso de Disputa, que es una declaración por escrito que establece el nombre, dirección e información de contacto de la parte que lo da, los hechos que dieron lugar a la disputa y el alivio solicitado. Debes enviar cualquier Aviso de Disputa por correo electrónico a: support@qrbrain.io. QRBrain.io enviará cualquier Aviso de Disputa a tu dirección si la tenemos, o de lo contrario a tu dirección de correo electrónico. Tú y QRBrain.io intentarán resolver cualquier disputa mediante negociación informal dentro de los sesenta (60) días posteriores a la fecha de envío del Aviso de Disputa. Después de sesenta (60) días, tú o QRBrain.io pueden iniciar un arbitraje.',
      },
      bindArb: {
        title: 'Arbitraje Vinculante',
        0: 'Si tú y QRBrain.io no resuelven ninguna disputa mediante negociación informal, cualquier otro esfuerzo para resolver la disputa se llevará a cabo exclusivamente mediante arbitraje vinculante según lo descrito en esta sección. Estás renunciando al derecho a litigar (o participar como parte o miembro de una clase) todas las disputas en un tribunal ante un juez o jurado. La disputa se resolverá mediante arbitraje vinculante de acuerdo con las reglas de arbitraje comercial de la Asociación Americana de Arbitraje. Cualquiera de las partes puede solicitar cualquier medida cautelar o preliminar ante cualquier tribunal de jurisdicción competente, según sea necesario para proteger los derechos o la propiedad de la parte en cuestión en espera de la finalización del arbitraje. Cualquier y todos los costos legales, contables y de otro tipo, honorarios y gastos incurridos por la parte ganadora serán asumidos por la parte no ganadora.',
      },
      subprivacy: {
        title: 'Envíos y Privacidad',
        0: 'En caso de que envíes o publiques alguna idea, sugerencia creativa, diseño, fotografía, información, anuncios, datos o propuestas, incluidas ideas para nuevos o mejores productos, servicios, características, tecnologías o promociones, aceptas expresamente que dichos envíos serán tratados automáticamente como no confidenciales y no patentados y se convertirán en propiedad exclusiva de QRBrain.io sin ninguna compensación o crédito para ti. QRBrain.io y sus afiliados no tendrán ninguna obligación con respecto a tales envíos o publicaciones y podrán utilizar las ideas contenidas en tales envíos o publicaciones para cualquier propósito en cualquier medio de forma perpetua, incluido, entre otros, el desarrollo, la fabricación y la comercialización de productos y servicios utilizando tales ideas.',
      },
      promotions: {
        title: 'Promociones',
        0: 'QRBrain.io puede, de vez en cuando, incluir concursos, promociones, sorteos u otras actividades (“Promociones”) que te requieran enviar material o información sobre ti. Ten en cuenta que todas las Promociones pueden regirse por reglas separadas que pueden contener ciertos requisitos de elegibilidad, como restricciones en cuanto a la edad y la ubicación geográfica. Es tu responsabilidad leer todas las reglas de Promociones para determinar si eres elegible para participar. Si participas en alguna Promoción, aceptas cumplir y acatar todas las Reglas de Promociones.',
        1: 'Pueden aplicarse términos y condiciones adicionales a las compras de bienes o servicios en o a través de los Servicios, cuyos términos y condiciones forman parte de este Acuerdo por esta referencia.',
      },
      typogrerror: {
        title: 'Errores Tipográficos',
        0: 'En el caso de que un producto y/o servicio se liste a un precio incorrecto o con información incorrecta debido a un error tipográfico, tendremos derecho a rechazar o cancelar cualquier pedido realizado para el producto y/o servicio listado a un precio incorrecto. Tendremos derecho a rechazar o cancelar dicho pedido, ya sea que el pedido haya sido confirmado o no y tu tarjeta de crédito haya sido cargada. Si tu tarjeta de crédito ya ha sido cargada por la compra y tu pedido es cancelado, emitiremos inmediatamente un crédito a tu cuenta de tarjeta de crédito u otra cuenta de pago por el monto del cargo.',
      },
      miscell: {
        title: 'Misceláneo',
        0: 'Si por alguna razón un tribunal de jurisdicción competente encuentra que alguna disposición o parte de estos Términos y Condiciones es inaplicable, el resto de estos Términos y Condiciones continuará en pleno vigor y efecto. Cualquier renuncia a cualquier disposición de estos Términos y Condiciones será efectiva solo si está por escrito y firmada por un representante autorizado de QRBrain.io. QRBrain.io tendrá derecho a medidas cautelares u otro alivio equitativo (sin la obligación de presentar ninguna fianza o garantía) en caso de cualquier incumplimiento o incumplimiento anticipado por tu parte. QRBrain.io opera y controla el Servicio QRBrain.io desde sus oficinas en AR. El Servicio no está destinado a ser distribuido ni utilizado por ninguna persona o entidad en ninguna jurisdicción o país donde dicha distribución o uso sea contrario a la ley o regulación. En consecuencia, aquellas personas que elijan acceder al Servicio QRBrain.io desde otras ubicaciones lo hacen por su propia iniciativa y son responsables de cumplir con las leyes locales, si y en la medida en que las leyes locales sean aplicables. Estos Términos y Condiciones (que incluyen e incorporan la Política de Privacidad de QRBrain.io) contienen el entendimiento completo, y reemplaza todos los entendimientos previos, entre tú y QRBrain.io en relación con su materia, y no pueden ser cambiados o modificados por ti. Los encabezados de sección utilizados en este Acuerdo son solo para conveniencia y no tendrán ningún significado legal.',
      },
      disclaimer: {
        title: 'Descargo de Responsabilidad',
        0: 'QRBrain.io no es responsable de ningún contenido, código o cualquier otra imprecisión.',
        1: 'QRBrain.io no proporciona garantías ni garantías.',
        2: 'En ningún caso QRBrain.io será responsable de ningún daño especial, directo, indirecto, consecuente o incidental ni de ningún daño en absoluto, ya sea en una acción de contrato, negligencia u otro agravio, que surja de o esté relacionado con el uso del Servicio o los contenidos del Servicio. La Compañía se reserva el derecho de realizar adiciones, eliminaciones o modificaciones a los contenidos del Servicio en cualquier momento sin previo aviso.',
        3: 'El Servicio QRBrain.io y sus contenidos se proporcionan "tal cual" y "según disponibilidad" sin ninguna garantía o representación de ningún tipo, ya sea expresa o implícita. QRBrain.io es un distribuidor y no un editor del contenido suministrado por terceros; como tal, QRBrain.io no ejerce ningún control editorial sobre dicho contenido y no ofrece ninguna garantía o representación sobre la exactitud, fiabilidad o actualidad de la información, contenido, servicio o mercancía proporcionada a través o accesible a través del Servicio QRBrain.io. Sin limitar lo anterior, QRBrain.io rechaza específicamente todas las garantías y representaciones en cualquier contenido transmitido en o en relación con el Servicio QRBrain.io o en sitios que puedan aparecer como enlaces en el Servicio QRBrain.io, o en los productos proporcionados como parte de, o de otro modo en conexión con, el Servicio QRBrain.io, incluidas, entre otras, garantías de comerciabilidad, idoneidad para un propósito particular o no infracción de derechos de terceros. Ningún consejo oral o información escrita proporcionada por QRBrain.io o cualquiera de sus afiliados, empleados, funcionarios, directores, agentes o similares creará una garantía. La información sobre precios y disponibilidad está sujeta a cambios sin previo aviso. Sin limitar lo anterior, QRBrain.io no garantiza que el Servicio QRBrain.io será ininterrumpido, sin corrupción, oportuno o libre de errores.',
      },
      contactus: {
        title: 'Contáctanos',
        0: 'No dudes en contactarnos si tienes alguna pregunta.',
        1: 'Vía Correo Electrónico: ',
      },
    },
    dataDeletion: {
      deleteAccountTitle: 'Eliminar cuenta y datos',
      deleteAccountIntro:
        'Valoramos su privacidad y entendemos que pueda querer eliminar su cuenta y los datos asociados. Esta página describe cómo puede eliminar su cuenta y cualquier dato relacionado con el uso de nuestro servicio, incluidos los datos obtenidos a través de servicios de inicio de sesión de terceros como Facebook.',
      deletingAccount: {
        title: 'Cómo eliminar su cuenta',
        title2: 'Si desea eliminar su cuenta, siga estos pasos:',
        step1: 'Inicia sesión en tu cuenta:',
        step1Desc:
          'Visita nuestro sitio web e inicia sesión utilizando tus credenciales de cuenta o mediante un proveedor de inicio de sesión de terceros, como Facebook.',
        step2: 'Navega a Configuración de la cuenta:',
        step2Desc:
          'Después de iniciar sesión, haz clic en el ícono de configuración en la esquina superior derecha de la pantalla.',
        step3: 'Solicita la eliminación de la cuenta:',
        step3Desc:
          "En la sección de Configuración de la cuenta, desplázate hacia abajo hasta el área de detalles de la cuenta. Haz clic en 'Eliminar cuenta' y sigue las instrucciones para confirmar la eliminación.",
        finalNote:
          'Una vez que se inicie el proceso de eliminación, su cuenta y los datos asociados se eliminarán permanentemente de nuestros servidores en un plazo de 7 días.',
      },
      deletingDataViaFacebook: {
        title: 'Eliminación de Datos a través del Inicio de Sesión de Facebook',
        title2:
          'Si te registraste utilizando tu cuenta de Facebook, también puedes eliminar los datos asociados a nuestra aplicación a través de Facebook directamente.',
        step1: 'Inicia sesión en Facebook:',
        step1Desc: 'Ve a Facebook e inicia sesión en tu cuenta.',
        step2: 'Accede a la Configuración de Aplicaciones y Sitios Web:',
        step2Desc:
          "Haz clic en la flecha hacia abajo en la esquina superior derecha de Facebook y selecciona 'Configuración y Privacidad', luego ve a 'Configuración'.Sitios Web'.",
        step3Desc: "En la barra lateral izquierda, selecciona 'Aplicaciones y Sitios Web'.",
        step3: 'Elimina Nuestra Aplicación:',
        step4Desc:
          "Encuentra nuestra aplicación en la sección Activa. Haz clic en 'Eliminar' para borrar el acceso de nuestra aplicación a los datos de tu cuenta de Facebook.",
        step5Desc:
          "Haz clic en 'Eliminar' para borrar el acceso de nuestra aplicación a los datos de tu cuenta de Facebook.",
        finalNote:
          'Eliminar nuestra aplicación de Facebook impedirá cualquier compartición de datos futura entre Facebook y nuestra plataforma, pero aún deberás eliminar tu cuenta en nuestra plataforma utilizando los pasos mencionados anteriormente.',
      },
      requestingDataDeletionManually: {
        title: 'Solicitud de Eliminación de Datos Manualmente',
        descriptionPart1:
          'Si encuentras algún problema con los pasos anteriores o prefieres asistencia manual, puedes contactar a nuestro equipo de soporte enviando un correo a',
        descriptionLink: 'support@qrbrain.io',
        descriptionPart2: " con el asunto 'Solicitud de eliminación de cuenta'.",
        requiredInfo: 'Por favor incluye:',
        step1: 'Tu nombre completo',
        step2: 'Tu dirección de correo electrónico (o cuenta de Facebook asociada con tu inicio de sesión)',
        step3: 'Cualquier otra información relevante que pueda ayudarnos a identificar tu cuenta.',
        finalNote:
          'Procesaremos tu solicitud dentro de los 30 días y confirmaremos una vez que tus datos hayan sido eliminados permanentemente.',
      },
      dataDeletion: {
        contactUsPart1:
          'Si tienes alguna otra pregunta sobre la gestión o eliminación de tus datos, no dudes en contactarnos en',
        contactUsLink: 'support@qrbrain.io',
        contactUsPart2: '.',
      },
    },
    common: {
      language: 'Idioma',
      createQrCodes: 'Crear códigos QR',
      createQrCode: 'Crear código QR',
      services: 'Servicios',
      listOfLinks: 'Lista de enlaces',
      vCard: 'vCard',
      vCardPlus: 'vCard Plus',
      showMore: 'Mostrar más',
      faq: {
        title: 'Preguntas frecuentes',
        qrGeneration: {
          title: '¿Qué significa la generación de QR?',
          description:
            'Es una herramienta que te permite crear fácilmente e intuitivamente varios tipos de códigos QR. Con la creciente popularidad de los códigos QR, nuestro generador se ha convertido en un recurso de referencia tanto para individuos como para empresas. Puede ser utilizado por empresas de todo tipo para crear códigos QR para sitios web, compartir PDFs, galerías de fotos, listas de reproducción, listas de precios o menús, conectar a los clientes con los servicios ofrecidos por tu negocio (como acceso WiFi, citas, pagos, etc.), promover eventos con enlaces a trailers, crear vCards con información de contacto para compartir con los clientes, y mucho más.',
        },
        createAccount: {
          title: '¿Puedo crear una cuenta para generar códigos QR de forma gratuita?',
          description:
            'Por supuesto, los primeros siete días son gratuitos, permitiéndote probar nuestro generador de códigos QR sin costo.',
        },
        freeAvailable: {
          title: '¿Los códigos QR están disponibles de forma gratuita?',
          description:
            'Nuestro generador de códigos QR ofrece una prueba gratuita de siete días, permitiéndote crear y mantener códigos QR permanentemente. Si estás satisfecho con el servicio, puedes elegir un plan que se ajuste a tus necesidades. Con una suscripción, tendrás acceso ilimitado a todas las funciones: crea códigos QR dinámicos y editables ilimitados, explora varios tipos de QR, administra y edita tus códigos QR, realiza un seguimiento ilimitado de escaneos, visualiza estadísticas completas y descarga en múltiples formatos.',
        },
      },
      someDescription: 'Alguna descripción',
      uploadFileFailed: 'Error al cargar, archivos demasiado grandes',
      startTypingHere: 'Comienza a escribir aquí',
      telephone: 'Teléfono',
      eg: 'Ej.',
      personalWebsite: 'Sitio web personal',
      typeHere: 'Escribe aquí...',
      enterName: 'Ingresa tu nombre aquí...',
      enterSurname: 'Ingresa tu apellido aquí...',
      enterCompanyName: 'Ingresa el nombre de tu empresa aquí...',
      enterTitleName: 'Ingresa el nombre del título aquí...',
      enterDescription: 'Ingresa tu descripción aquí...',
      uploadPDF: 'Subir PDF(s)',
      maxSize: 'Tamaño máximo',
      writeLinkText: 'Escribe el texto del enlace aquí...',
      enterAppNameHere: 'Ingresa el nombre de la aplicación aquí...',
      writeButtonText: 'Escribe el texto del botón aquí...',
      color: 'Color',
      youTubeError: 'La URL debe ser un enlace válido a un video de YouTube (formato: youtube.com/watch?v=...)',
      actions: 'Comportamiento',
    },
    contactUs: {
      title: 'Contáctanos',
      nameSurname: 'Nombre y apellido *',
      nameSurnameEg: 'Ej. Paul Jones',
      email: 'Dirección de correo electrónico *',
      emailEg: 'Ej. nombre@email.com',
      subject: 'Asunto *',
      question: 'Pregunta/Consulta *',
      questionEg: 'Ej. Lorem ipsum',
      send: 'Enviar',
      subjectPlaceholder: 'Asunto...',
    },
    qrTable: {
      scanLimit: 'Scan Limit',
      untitled: 'Sin título',
      noFolder: 'Sin carpeta',
      notCreated: 'Aún no has creado ningún código QR. Todos los que crees se mostrarán en esta página.',
      draft: 'Borrador',
    },
    builder: {
      qrType: 'Tipo de QR',
      linkToWebsite: 'Enlace a la URL del sitio web',
      showPDFFile: 'Mostrar archivo PDF',
      shareLinks: 'Compartir enlaces',
      shareDifferentImage: 'Compartir imágenes diferentes',
      yourSocialChannels: 'Tus canales sociales',
      digitalBusinessCard: 'Tarjeta de presentación digital',
      change: 'Cambiar',
      video: {
        video: {
          title: 'Video',
          videoUrl: 'URL del video',
          addVideo: 'Agregar video',
          uploadVideo: 'Subir video(s)',
          showDirectly: 'Mostrar el video directamente',
        },
        information: {
          title: 'Información',
          videoTitle: 'Título del video',
          addButton: 'Agregar botón',
          buttonText: 'Texto del botón',
          buttonUrl: 'URL',
        },
      },
      coupon: {
        offer: {
          title: 'Información de la oferta',
          salesBadge: 'Etiqueta de oferta',
          codeButton: 'Botón para ver el código',
          companyPlaceholder: 'Ej.: Super Hamburguesas de John',
          titlePlaceholder: 'Ej.: Las mejores hamburguesas de la ciudad',
          salesBadgePlaceholder: 'Ej.: 10% de descuento',
          codeButtonPlaceholder: 'Ej.: Obtener cupón',
        },

        coupon: {
          useBarcode: 'Usar código de barras',
          barcodeTitle: 'Código de barras (640 x 360px)',
          title: 'Información del cupón',
          code: 'Código del cupón',
          validUntil: 'Válido hasta',
          terms: 'Términos y condiciones',
          codePlaceholder: 'Ej.: SALE25',
          termsPlaceholder: 'Proporciona los términos y condiciones de tu cupón',
          seeLocation: 'Ver ubicación',
          copyCode: 'Copiar código',
          termsWithCond: 'Términos y condiciones',
        },
      },
      designStep: {
        frame: {
          description: 'Diseña un marco exterior para que tu QR destaque.',
          frameText: 'Texto del Marco',
          frameBg: 'Color de Fondo del Marco',
          fontStyle: 'Estilo de Fuente',
        },
        pattern: {
          title: 'Estilo',
          description: 'Personaliza los módulos del QR (puntos/cuadrados que componen el código).',
          patternColor: 'Color del patrón',
        },
        cornerStyle: {
          title: 'Estilo de esquina',
          description: 'Estiliza los marcos y puntos de las esquinas del QR.',
          cornerFrame: {
            title: 'Marco de esquina',
            cornerFrameStyle: 'Estilo del marco alrededor de los puntos de esquina',
            cornerFrameColor: 'Color del marco alrededor de los puntos de esquina',
          },
          cornerDots: 'Puntos de esquina',
          cornerDotsColor: 'Color de los puntos de esquina',
        },
        errorCorrectionLevel: {
          description:
            'Asegura una lectura confiable compensando daños o distorsiones. Elegir un nivel más alto mejora la legibilidad, aunque puede aumentar el tamaño del QR.',
          infoText: 'Niveles más altos aumentan la fiabilidad del escaneo, pero resultan en un código QR más denso.',
        },
        logo: {
          title: 'Logo',
          description: 'Inserta un logotipo en el centro de tu código QR.',
        },
      },
      testScan: {
        title: 'Escaneo de Prueba',
        testCode: 'Prueba tu Código QR',
        description: 'Usa la cámara de tu teléfono para escanear este código QR y ver cómo funciona.',
        howToTest: {
          title: 'Cómo probar:',
          step1: 'Abre la aplicación de cámara de tu smartphone',
          step2: 'Apunta hacia el código QR',
          step3: 'Cuando aparezca una notificación, tócala',
          step4: 'Serás llevado directamente al contenido vinculado',
        },
      },
      nameAndFolder: {
        folder: 'Carpeta',
        noFolder: 'Sin carpeta',
        createFolder: 'Crear carpeta',
        createNewFolder: 'Crear nueva carpeta',
      },
    },
    folders: {
      myFolders: 'Mis carpetas',
      editFolderName: 'Editar nombre de la carpeta',
      changeFolderName: 'Cambiar nombre de la carpeta',
      downloadQRs: 'Descargar QRs',
      deleteFolder: 'Eliminar carpeta',
      searchFolder: 'Buscar carpeta...',
      sortBy: 'Ordenar por',
      mostRecent: 'Más reciente',
      oldest: 'Más antiguo',
      selectOrCreateFolder: 'Selecciona una carpeta o crea una nueva',
      selectFolderDescription:
        'Los códigos QR seleccionados se guardarán en la carpeta que elijas. Puedes ayudarte con la función de búsqueda.',
      emptyFolders: 'Aún no tienes carpetas...',
      deleteFolderQuestion: '¿Estás seguro de que deseas eliminar esta carpeta?',
      noResults: 'No se encontraron resultados...',
      noQRsInFolder: 'No tienes ningún código QR en esta carpeta.',
    },
  },
} as const;
